import * as i0 from '@angular/core';
import { Injectable, Component, Input, Inject, EventEmitter, ChangeDetectionStrategy, Output, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import * as Highcharts from 'highcharts';
import * as i2 from '@angular/forms';
import { FormControl, FormRecord, FormArray, Validators, ReactiveFormsModule } from '@angular/forms';
import * as i1$2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Subscription, from } from 'rxjs';
import * as i5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i7 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i8 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i9 from '@angular/material/core';
import { MatOptionModule } from '@angular/material/core';
import * as i10 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i11 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import * as i12 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import highcharts from 'highcharts/modules/pattern-fill';
import highcharts0 from 'highcharts/highcharts-more';
import highcharts01 from 'highcharts/modules/exporting';
import highcharts012 from 'highcharts/modules/offline-exporting';
import highcharts0123 from 'highcharts/modules/boost';
import highcharts01234 from 'highcharts/modules/no-data-to-display';
import { cloneDeep } from 'lodash';
import * as i10$1 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i11$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';

class BaseService {
    serviceBaseUrl;
    baseUrlPrefix = '';
    constructor(serviceBaseUrl) {
        this.serviceBaseUrl = serviceBaseUrl;
    }
    setBaseUrlPrefix(prefix) {
        this.baseUrlPrefix = prefix;
    }
    get baseUrl() {
        return `${this.baseUrlPrefix}${this.serviceBaseUrl}`;
    }
}

class JobsiteService extends BaseService {
    http;
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    constructor(http) {
        super('api/jobsites');
        this.http = http;
    }
    createJobsite(jobsite) {
        return this.http.post(this.baseUrl, jobsite);
    }
    updateJobsite(jobsiteId, jobsite) {
        return this.http.put(`${this.baseUrl}/${jobsiteId}`, jobsite);
    }
    getJobsiteById(jobsiteId) {
        return this.http.get(`${this.baseUrl}/${jobsiteId}`);
    }
    deleteJobsite(jobsiteId) {
        return this.http.delete(`${this.baseUrl}/${jobsiteId}`);
    }
    getAllJobsites() {
        return this.http.get(this.baseUrl);
    }
    searchJobsites(search) {
        search = search.replace(/'/g, ' '); // temporary fix for ' which dont pass lucene queries
        return this.http.post(`${this.baseUrl}/search`, { search }, this.httpOptions);
    }
    searchVisibleJobsites(polygon) {
        return this.http.get(`${this.baseUrl}/geoloc?polygon=${polygon}`);
    }
    getAllReadyJobsites() {
        return this.http.get(`${this.baseUrl}/ready`);
    }
    getJobsiteSurveys(jobsiteId) {
        return this.http.get(`${this.baseUrl}/${jobsiteId}/soil_surveys`);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: JobsiteService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: JobsiteService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: JobsiteService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class JobsiteSoilStatsComponent {
    globalStats;
    titleBlockGrayed = true;
    noDataTextColor = 'black';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: JobsiteSoilStatsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: JobsiteSoilStatsComponent, selector: "ssd-soillib-lib-jobsite-soil-stats", inputs: { globalStats: "globalStats", titleBlockGrayed: "titleBlockGrayed", noDataTextColor: "noDataTextColor" }, ngImport: i0, template: "<div class=\"ssd-soillib-lib-jobsite-soil-stats\">\n  <div\n    class=\"title-text\"\n    [style.background-color]=\"titleBlockGrayed ? '#c6c6c6' : 'unset'\"\n  >\n    <h3>{{ 'JOBSITE_SOIL_STATS.TITLE' | translate }}</h3>\n    <p>{{ 'JOBSITE_SOIL_STATS.DESCRIPTION' | translate }}</p>\n  </div>\n\n  <div\n    class=\"global-stats-content\"\n    *ngIf=\"globalStats?.data?.length; else noData\"\n  >\n    <h4>\n      {{\n        'JOBSITE_SOIL_STATS.DEPTH_DATA'\n          | translate\n            : {\n                startDepth:\n                  globalStats?.start_depth != null\n                    ? globalStats.start_depth\n                    : 'N/A',\n                endDepth:\n                  globalStats?.end_depth != null ? globalStats.end_depth : 'N/A'\n              }\n      }}\n    </h4>\n\n    <div\n      *ngFor=\"let item of globalStats?.data\"\n      class=\"element flex-layout-row flex-align-start\"\n    >\n      <div class=\"flex-70\">\n        {{ 'SOIL_TYPES.' + item.soil_type.toUpperCase() | translate }}\n      </div>\n      <div class=\"flex-30\">\n        {{\n          'JOBSITE_SOIL_STATS.DATA_VALUE_PERCENTAGE'\n            | translate\n              : { value: item.percentage != null ? item.percentage : 'N/A' }\n        }}\n      </div>\n    </div>\n  </div>\n\n  <ng-template #noData>\n    <div class=\"no-data-message\" [style.color]=\"noDataTextColor\">\n      {{ 'JOBSITE_SOIL_STATS.NO_STATS' | translate }}\n    </div>\n  </ng-template>\n</div>\n", styles: [".ssd-soillib-lib-jobsite-soil-stats .title-text{display:grid;padding-left:20px;padding-right:10px}.ssd-soillib-lib-jobsite-soil-stats .global-stats-content{padding-left:20px;padding-right:20px}.ssd-soillib-lib-jobsite-soil-stats .global-stats-content .element{border-bottom:#c6c6c6 1px dotted}.ssd-soillib-lib-jobsite-soil-stats .no-data-message{padding-top:20px;text-align:center;font-size:large}\n"], dependencies: [{ kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: JobsiteSoilStatsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ssd-soillib-lib-jobsite-soil-stats', template: "<div class=\"ssd-soillib-lib-jobsite-soil-stats\">\n  <div\n    class=\"title-text\"\n    [style.background-color]=\"titleBlockGrayed ? '#c6c6c6' : 'unset'\"\n  >\n    <h3>{{ 'JOBSITE_SOIL_STATS.TITLE' | translate }}</h3>\n    <p>{{ 'JOBSITE_SOIL_STATS.DESCRIPTION' | translate }}</p>\n  </div>\n\n  <div\n    class=\"global-stats-content\"\n    *ngIf=\"globalStats?.data?.length; else noData\"\n  >\n    <h4>\n      {{\n        'JOBSITE_SOIL_STATS.DEPTH_DATA'\n          | translate\n            : {\n                startDepth:\n                  globalStats?.start_depth != null\n                    ? globalStats.start_depth\n                    : 'N/A',\n                endDepth:\n                  globalStats?.end_depth != null ? globalStats.end_depth : 'N/A'\n              }\n      }}\n    </h4>\n\n    <div\n      *ngFor=\"let item of globalStats?.data\"\n      class=\"element flex-layout-row flex-align-start\"\n    >\n      <div class=\"flex-70\">\n        {{ 'SOIL_TYPES.' + item.soil_type.toUpperCase() | translate }}\n      </div>\n      <div class=\"flex-30\">\n        {{\n          'JOBSITE_SOIL_STATS.DATA_VALUE_PERCENTAGE'\n            | translate\n              : { value: item.percentage != null ? item.percentage : 'N/A' }\n        }}\n      </div>\n    </div>\n  </div>\n\n  <ng-template #noData>\n    <div class=\"no-data-message\" [style.color]=\"noDataTextColor\">\n      {{ 'JOBSITE_SOIL_STATS.NO_STATS' | translate }}\n    </div>\n  </ng-template>\n</div>\n", styles: [".ssd-soillib-lib-jobsite-soil-stats .title-text{display:grid;padding-left:20px;padding-right:10px}.ssd-soillib-lib-jobsite-soil-stats .global-stats-content{padding-left:20px;padding-right:20px}.ssd-soillib-lib-jobsite-soil-stats .global-stats-content .element{border-bottom:#c6c6c6 1px dotted}.ssd-soillib-lib-jobsite-soil-stats .no-data-message{padding-top:20px;text-align:center;font-size:large}\n"] }]
        }], propDecorators: { globalStats: [{
                type: Input
            }], titleBlockGrayed: [{
                type: Input
            }], noDataTextColor: [{
                type: Input
            }] } });

class SoilStatsService extends BaseService {
    http;
    constructor(http) {
        super('api/soilstats');
        this.http = http;
    }
    getJobsiteSoilStats(jobsiteId) {
        return this.http.get(`${this.baseUrl}/jobsite/stats/${jobsiteId}`);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilStatsService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilStatsService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilStatsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class SoilSurveyService extends BaseService {
    http;
    constructor(http) {
        super('api/soil_surveys');
        this.http = http;
    }
    /** Soil Survey **/
    createSoilSurvey(soilSurvey) {
        return this.http.post(this.baseUrl, soilSurvey);
    }
    getSoilSurvey(soilSurveyId) {
        return this.http.get(`${this.baseUrl}/${soilSurveyId}`);
    }
    updateSoilSurvey(soilSurveyId, soilSurvey) {
        return this.http.put(`${this.baseUrl}/${soilSurveyId}`, soilSurvey);
    }
    deleteSoilSurvey(soilSurveyId) {
        return this.http.delete(`${this.baseUrl}/${soilSurveyId}`);
    }
    searchSoilSurveys(lat, lon, radius) {
        return this.http.get(`${this.baseUrl}/geoloc?lat=${lat}&lon=${lon}&radius=${radius}`);
    }
    searchVisibleSoilSurveys(polygon) {
        return this.http.get(`${this.baseUrl}/geoloc/visible?polygon=${polygon}`);
    }
    /** Soil Survey Data **/
    saveSurveyData(surveyData, soilSurveyId) {
        return this.http.post(`${this.baseUrl}/${soilSurveyId}/data`, surveyData);
    }
    getSurveyData(soilSurveyId) {
        return this.http.get(`${this.baseUrl}/${soilSurveyId}/data`);
    }
    getSurveysData(soilSurveyIds) {
        return this.http.post(`${this.baseUrl}/data`, soilSurveyIds);
    }
    deleteSurveyData(soilSurveyId) {
        return this.http.delete(`${this.baseUrl}/${soilSurveyId}/data`);
    }
    getSoilSurveyAvailableParameters() {
        return this.http
            .get(`${this.baseUrl}/availableparameters`)
            .pipe(map(data => data.filter(el => el.type !== 'uuid')), map(data => data.map(el => el.column_name)));
    }
    /** Lab Test Data **/
    saveLabTestDataToSurvey(soilSurveyId, labTestData) {
        return this.http.post(`${this.baseUrl}/${soilSurveyId}/labtestdata`, labTestData);
    }
    getLabTestDataBySurveyId(soilSurveyId) {
        return this.http.get(`${this.baseUrl}/${soilSurveyId}/labtestdata`);
    }
    deleteLabTestData(soilSurveyId) {
        return this.http.delete(`${this.baseUrl}/${soilSurveyId}/labtestdata`);
    }
    getLabTestParameters() {
        return this.http
            .get(`${this.baseUrl}/labtestparameters`)
            .pipe(map(data => data.filter(el => el.type !== 'uuid')), map(data => data.map(el => el.column_name)));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilSurveyService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilSurveyService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilSurveyService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

const ChartIdList = ['qt', 'rf', 'u', 'icRolling', 'sbt'];
const yAxisTitle = {
    qt: 'qt(MPa)',
    rf: 'Rf(%)',
    u: 'U(kPa)',
    icRolling: 'Ic',
    sbt: 'SBTn (Robertson, 1990)',
};
const chartTitle = {
    qt: 'Cone resistance',
    rf: 'Friction ratio',
    u: 'Pore pressure',
    icRolling: 'SBTn Index',
    sbt: 'Norm. Soil Behaviour Type',
};
var SbtnZoneColor;
(function (SbtnZoneColor) {
    SbtnZoneColor["ZONE2"] = "#b86614";
    SbtnZoneColor["ZONE3"] = "#003671";
    SbtnZoneColor["ZONE4"] = "#0b850b";
    SbtnZoneColor["ZONE5"] = "#16b84e";
    SbtnZoneColor["ZONE6"] = "#b38a00";
    SbtnZoneColor["ZONE7"] = "#fea347";
})(SbtnZoneColor || (SbtnZoneColor = {}));
var SbtnZoneDesc;
(function (SbtnZoneDesc) {
    SbtnZoneDesc["ZONE2"] = "Organic soils - clay like";
    SbtnZoneDesc["ZONE3"] = "Clays - silty clay to clay like";
    SbtnZoneDesc["ZONE4"] = "Silt mixtures - clayey silt to silty clay like";
    SbtnZoneDesc["ZONE5"] = "Sand mixtures - silty sand to sandy silt like";
    SbtnZoneDesc["ZONE6"] = "Sands - clean sand to silty sand like";
    SbtnZoneDesc["ZONE7"] = "Gravelly sand to dense sand like";
})(SbtnZoneDesc || (SbtnZoneDesc = {}));

function getZone(ic) {
    if (ic === null || ic < 1 || ic > 4) {
        return null;
    }
    if (ic < 1.31) {
        return 'ZONE7';
    }
    else if (ic >= 1.31 && ic < 2.05) {
        return 'ZONE6';
    }
    else if (ic >= 2.05 && ic < 2.6) {
        return 'ZONE5';
    }
    else if (ic >= 2.6 && ic < 2.95) {
        return 'ZONE4';
    }
    else if (ic >= 2.95 && ic < 3.6) {
        return 'ZONE3';
    }
    else if (ic >= 3.6) {
        return 'ZONE2';
    }
    return null;
}
function getPolygonData(from, to, y) {
    return [
        [from, 0],
        [from, y],
        [to, y],
        [to, 0],
    ];
}
function getY(type) {
    return Number(type?.match(/\d+/)[0]);
}
function getPlotBands() {
    return [
        {
            from: 0.0,
            to: 1.31,
            color: SbtnZoneColor.ZONE7,
            label: {
                text: '7',
                style: {
                    color: 'white',
                },
            },
        },
        {
            from: 1.31,
            to: 2.05,
            color: SbtnZoneColor.ZONE6,
            label: {
                text: '6',
                style: {
                    color: 'white',
                },
            },
        },
        {
            from: 2.05,
            to: 2.6,
            color: SbtnZoneColor.ZONE5,
            label: {
                text: '5',
                style: {
                    color: 'white',
                },
            },
        },
        {
            from: 2.6,
            to: 2.95,
            color: SbtnZoneColor.ZONE4,
            label: {
                text: '4',
                style: {
                    color: 'white',
                },
            },
        },
        {
            from: 2.95,
            to: 3.6,
            color: SbtnZoneColor.ZONE3,
            label: {
                text: '3',
                style: {
                    color: 'white',
                },
            },
        },
        {
            from: 3.6,
            to: 4,
            color: SbtnZoneColor.ZONE2,
            label: {
                text: '2',
                style: {
                    color: 'white',
                },
            },
        },
    ];
}

const SOIL_TYPE_AGS_FR = {
    'TERRE VÉGÉTALE': 'TOPSOIL',
    REMBLAIS: 'MADE GROUND',
    'MATÉRIAU BITUMINEUX': 'Bitumen',
    BETON: 'CONCRETE',
    ARGILE: 'CLAY',
    'ARGILE LIMONEUSE': 'Silty CLAY',
    'ARGILE SABLEUSE': 'Sandy CLAY',
    'ARGILE GRAVELEUSE': 'Gravelly CLAY',
    'ARGILE À GALETS': 'Cobbly CLAY',
    'ARGILE À BLOCS': 'Bouldery CLAY',
    'ARGILE SABLO-LIMONEUSE': 'Silty CLAY',
    'ARGILE GRAVELO-LIMONEUSE': 'Silty CLAY',
    'ARGILE LIMONEUSE À GALETS': 'Silty CLAY',
    'ARGILE LIMONEUSE À BLOCS': 'Silty CLAY',
    'ARGILE SABLO-GRAVELO-LIMONEUSE': 'Silty CLAY',
    'ARGILE SABLO-LIMONEUSE À GALETS': 'Silty CLAY',
    'ARGILE SABLO-LIMONEUSE À BLOCS': 'Silty CLAY',
    'ARGILE SABLO-GRAVELO-LIMONEUSE À GALETS ET BLOCS': 'Silty CLAY',
    'ARGILE SABLO-GRAVELO-LIMONEUSE À BLOCS': 'Silty CLAY',
    // "ARGILE SABLO-GRAVELO-LIMONEUSE À GALETS ET BLOCS":           "Silty CLAY",
    'ARGILE TOURBEUSE SABLO-LIMONEUSE': 'Silty CLAY',
    'ARGILE TOURBEUSE SABLO-GRAVELO-LIMONEUSE': 'Silty CLAY',
    'ARGILE TOURBEUSE LIMONEUSE': 'Silty CLAY',
    'ARGILE SABLO-GRAVELEUSE': 'Sandy CLAY',
    'ARGILE SABLEUSE À GALETS': 'Sandy CLAY',
    'ARGILE SABLEUSE À BLOCS': 'Sandy CLAY',
    'ARGILE SABLO-GRAVELEUSE À GALETS': 'Sandy CLAY',
    'ARGILE SABLO-GRAVELEUSE À BLOCS': 'Sandy CLAY',
    'ARGILE SABLO-GRAVELEUSE À GALETS ET BLOCS': 'Sandy CLAY',
    'ARGILE TOURBEUSE SABLEUSE': 'Sandy CLAY',
    'ARGILE TOURBEUSE SABLO-GRAVELEUSE': 'Sandy CLAY',
    'ARGILE TOURBEUSE': 'Organic CLAY',
    LIMON: 'SILT',
    'ARGILE/LIMON': 'CLAY SILT',
    'LIMON SABLEUX': 'Sandy SILT',
    'LIMON GRAVELEUX': 'Gravelly SILT',
    'LIMON TOURBEUX': 'Organic SILT',
    'LIMON SABLO-GRAVELEUX': 'Sandy SILT',
    'LIMON TOURBEUX ARGILO-SABLO-GRAVELEUX À GALETS': 'Clayey SILT',
    'LIMON SABLEUX À GALETS': 'Sandy SILT',
    'LIMON SABLEUX À BLOCS': 'Sandy SILT',
    'LIMON TOURBEUX SABLEUX': 'Sandy SILT',
    'LIMON TOURBEUX SABLO-GRAVELEUX': 'Sandy SILT',
    'LIMON SABLO-GRAVELEUX À GALETS': 'Sandy SILT',
    'LIMON TOURBEUX SABLO-GRAVELEUX À GALETS': 'Sandy SILT',
    'LIMON GRAVELEUX À GALETS': 'Gravelly SILT',
    'LIMON GRAVELEUX À BLOCS': 'Gravelly SILT',
    'LIMON TOURBEUX GRAVELEUX': 'Gravelly SILT',
    'LIMON TOURBEUX GRAVELEUX À GALETS': 'Gravelly SILT',
    'LIMON À GALETS': 'Cobbly SILT',
    'LIMON À GALETS ET BLOCS': 'Cobbly SILT',
    'LIMON TOURBEUX À GALETS': 'Cobbly SILT',
    'LIMON À BLOCS': 'Bouldery SILT',
    SABLE: 'SAND',
    'SABLE ARGILEUX': 'Clayey SAND',
    'SABLE LIMONEUX': 'Silty SAND',
    'SABLE GRAVELEUX': 'Gravelly SAND',
    'SABLE À GALETS': 'Cobbly SAND',
    'SABLE À BLOCS': 'Bouldery SAND',
    'SABLE ARGILO-GRAVELEUX': 'Clayey SAND',
    'SABLE ARGILO-GRAVELEUX À GALETS': 'Clayey SAND',
    'SABLE LIMONO-GRAVELEUX': 'Silty SAND',
    'SABLE LIMONO-GRAVELEUX À GALETS': 'Silty SAND',
    'SABLE LIMONO-GRAVELEUX À GALETS ET BLOCS': 'Silty SAND',
    'SABLE GRAVELEUX À GALETS': 'Gravelly SAND',
    'SABLE GRAVELEUX À GALETS ET BLOCS': 'Gravelly SAND',
    'SABLE GRAVELEUX À BLOCS': 'Gravelly SAND',
    'SABLE À GALETS ET BLOCS': 'Cobbly SAND',
    'SABLE ET GRAVIERS': 'SAND and GRAVEL',
    'SABLE TOURBEUX': 'Organic SAND',
    'SABLE TOURBEUX LIMONEUX': 'Silty SAND',
    'SABLE TOURBEUX GRAVELEUX': 'Gravelly SAND',
    'SABLE TOURBEUX À GALETS': 'Cobbly SAND',
    'SABLE TOURBEUX À BLOCS': 'Bouldery SAND',
    GRAVIER: 'GRAVEL',
    'GRAVIER ARGILEUX': 'Clayey GRAVEL',
    'GRAVIER LIMONEUX': 'Silty GRAVEL',
    'GRAVIER SABLEUX': 'Sandy GRAVEL',
    'GRAVIER TOURBEUX': 'Organic GRAVEL',
    'GRAVIER À GALETS': 'Cobbly GRAVEL',
    'GRAVIER À BLOCS': 'Bouldery GRAVEL',
    'GRAVIER ARGILO-SABLEUX': 'Clayey GRAVEL',
    'GRAVIER ARGILEUX À GALETS': 'Clayey GRAVEL',
    'GRAVIER ARGILEUX À BLOCS': 'Clayey GRAVEL',
    'GRAVIER TOURBEUX ARGILEUX': 'Clayey GRAVEL',
    'GRAVIER TOURBEUX ARGILO-SABLEUX': 'Clayey GRAVEL',
    'GRAVIER LIMONO-SABLEUX': 'Silty GRAVEL',
    'GRAVIER LIMONEUX À GALETS': 'Silty GRAVEL',
    'GRAVIER LIMONEUX À BLOCS': 'Silty GRAVEL',
    'GRAVIER TOURBEUX LIMONEUX': 'Silty GRAVEL',
    'GRAVIER TOURBEUX LIMONO-SABLEUX': 'Silty GRAVEL',
    'GRAVIER SABLEUX À GALETS': 'Sandy GRAVEL',
    'GRAVIER SABLEUX À BLOCS': 'Sandy GRAVEL',
    'GRAVIER TOURBEUX SABLEUX': 'Sandy GRAVEL',
    'GRAVIER LIMONO-SABLEUX À GALETS': 'Silty GRAVEL',
    TOURBE: 'PEAT',
    'TOURBE ARGILEUSE': 'Clayey PEAT',
    'TOURBE LIMONEUSE': 'Silty PEAT',
    'TOURBE SABLEUSE': 'Sandy PEAT',
    'TOURBE GRAVELEUSE': 'Gravelly PEAT',
    'TOURBE À GALETS': 'Cobbly PEAT',
    'TOURBE ARGILO-SABLEUSE': 'Clayey PEAT',
    'TOURBE ARGILO-GRAVELEUSE': 'Clayey PEAT',
    'TOURBE LIMONO-SABLEUSE': 'Silty PEAT',
    'TOURBE LIMONO-SABLO-GRAVELEUSE': 'Silty PEAT',
    'TOURBE SABLO-GRAVELEUSE': 'Sandy PEAT',
    GALETS: 'COBBLES',
    'GALETS ARGILEUX': 'Clayey COBBLES',
    'GALETS LIMONEUX': 'Silty COBBLES',
    'GALETS SABLEUX': 'Sandy COBBLES',
    'GALETS GRAVELEUX': 'Gravelly COBBLES',
    'GALETS TOURBEUX': 'Organic COBBLES',
    'GALETS ARGILO-SABLEUX': 'Clayey COBBLES',
    'GALETS ARGILO-GRAVELEUX': 'Clayey COBBLES',
    'GALETS LIMONO-SABLEUX': 'Silty COBBLES',
    'GALETS LIMONO-GRAVELEUX': 'Silty COBBLES',
    'GALETS TOURBEUX LIMONEUX': 'Silty COBBLES',
    'GALETS LIMONO-GRAVELO-SABLEUX': 'Silty COBBLES',
    'GALETS TOURBEUX LIMONO-SABLEUX': 'Silty COBBLES',
    'GALETS TOURBEUX LIMONO-SABLO-GRAVELEUX': 'Silty COBBLES',
    'GALETS SABLO-GRAVELEUX': 'Sandy COBBLES',
    'GALETS TOURBEUX SABLEUX': 'Sandy COBBLES',
    'GALETS TOURBEUX GRAVELEUX': 'Gravelly COBBLES',
    'GALETS ET BLOCS': 'COBBLES and BOULDERS',
    BLOCS: 'BOULDERS',
    'BLOCS GRAVELEUX À GALETS': 'Gravelly BOULDERS',
    PELLITE: 'MUDSTONE',
    SILTITE: 'SILTSTONE',
    GRES: 'SANDSTONE',
    CALCAIRE: 'LIMESTONE',
    CRAIE: 'CHALK',
    CHARBON: 'COAL',
    BRECHE: 'BRECCIA',
    CONGLOMERAT: 'CONGLOMERATE',
    'ROCHE MAGMATIQUE': 'Igneous ROCK',
    'ROCHE METAMORPHIQUE': 'Metamorphic ROCK',
    'ROCHE PYROCLASTIQUE': 'ROCK',
    GYPSE: 'Gypsum',
    SCHISTE: 'Shale',
    VIDE: 'Void',
    'PAS DE RÉCUPÉRATION': 'No Rec',
    INDÉTERMINÉ: 'Undetermined',
    BOIS: 'Wood',
};
const SOIL_TYPE_AGS_EN = {
    TOPSOIL: 'TOPSOIL',
    'MADE GROUND': 'MADE GROUND',
    'BITUMINOUS MATERIAL': 'Bitumen',
    CONCRETE: 'CONCRETE',
    CLAY: 'CLAY',
    'SILTY CLAY': 'Silty CLAY',
    'SANDY CLAY': 'Sandy CLAY',
    'GRAVELLY CLAY': 'Gravelly CLAY',
    'COBBLY CLAY': 'Cobbly CLAY',
    'BOULDERY CLAY': 'Bouldery CLAY',
    'SILTY SANDY CLAY': 'Silty CLAY',
    'SILTY GRAVELLY CLAY': 'Silty CLAY',
    'SILTY COBBLY CLAY': 'Silty CLAY',
    'SILTY BOULDERY CLAY': 'Silty CLAY',
    'SILTY SANDY GRAVELLY CLAY': 'Silty CLAY',
    'SILTY SANDY COBBLY CLAY': 'Silty CLAY',
    'SILTY SANDY BOULDERY CLAY': 'Silty CLAY',
    'SILTY SANDY GRAVELLY COBBLY CLAY': 'Silty CLAY',
    'SILTY SANDY GRAVELLY BOULDERY CLAY': 'Silty CLAY',
    'SILTY SANDY GRAVELLY COBBLY BOULDERY CLAY': 'Silty CLAY',
    'SILTY SANDY ORGANIC CLAY': 'Silty CLAY',
    'SILTY SANDY GRAVELLY ORGANIC CLAY': 'Silty CLAY',
    'SILTY ORGANIC CLAY': 'Silty CLAY',
    'SANDY GRAVELLY CLAY': 'Sandy CLAY',
    'SANDY COBBLY CLAY': 'Sandy CLAY',
    'SANDY BOULDERY CLAY': 'Sandy CLAY',
    'SANDY GRAVELLY COBBLY CLAY': 'Sandy CLAY',
    'SANDY GRAVELLY BOULDERY CLAY': 'Sandy CLAY',
    'SANDY GRAVELLY COBBLY BOULDERY CLAY': 'Sandy CLAY',
    'SANDY ORGANIC CLAY': 'Sandy CLAY',
    'SANDY GRAVELLY ORGANIC CLAY': 'Sandy CLAY',
    'ORGANIC CLAY': 'Organic CLAY',
    SILT: 'SILT',
    'CLAY/SILT': 'CLAY SILT',
    'SANDY SILT': 'Sandy SILT',
    'GRAVELLY SILT': 'Gravelly SILT',
    'ORGANIC SILT': 'Organic SILT',
    'SANDY GRAVELLY SILT': 'Sandy SILT',
    'CLAYEY SANDY GRAVELLY ORGANIC COBBLY SILT': 'Clayey SILT',
    'SANDY COBBLY SILT': 'Sandy SILT',
    'SANDY BOULDERY SILT': 'Sandy SILT',
    'SANDY ORGANIC SILT': 'Sandy SILT',
    'SANDY GRAVELLY ORGANIC SILT': 'Sandy SILT',
    'SANDY GRAVELLY COBBLY SILT': 'Sandy SILT',
    'SANDY GRAVELLY ORGANIC COBBLY SILT': 'Sandy SILT',
    'GRAVELLY COBBLY SILT': 'Gravelly SILT',
    'GRAVELLY BOULDERY SILT': 'Gravelly SILT',
    'GRAVELLY ORGANIC SILT': 'Gravelly SILT',
    'GRAVELLY ORGANIC COBBLY SILT': 'Gravelly SILT',
    'COBBLY SILT': 'Cobbly SILT',
    'COBBLY BOULDERY SILT': 'Cobbly SILT',
    'ORGANIC COBBLY SILT': 'Cobbly SILT',
    'BOULDERY SILT': 'Bouldery SILT',
    SAND: 'SAND',
    'CLAYEY SAND': 'Clayey SAND',
    'SILTY SAND': 'Silty SAND',
    'GRAVELLY SAND': 'Gravelly SAND',
    'COBBLY SAND': 'Cobbly SAND',
    'BOULDERY SAND': 'Bouldery SAND',
    'CLAYEY GRAVELLY SAND': 'Clayey SAND',
    'CLAYEY GRAVELLY COBBLY SAND': 'Clayey SAND',
    'SILTY GRAVELLY SAND': 'Silty SAND',
    'SILTY GRAVELLY COBBLY SAND': 'Silty SAND',
    'SILTY GRAVELLY COBBLY BOULDERY SAND': 'Silty SAND',
    'GRAVELLY COBBLY SAND': 'Gravelly SAND',
    'GRAVELLY COBBLY BOULDERY SAND': 'Gravelly SAND',
    'GRAVELLY BOULDERY SAND': 'Gravelly SAND',
    'COBBLY BOULDERY SAND': 'Cobbly SAND',
    'SAND AND GRAVEL': 'SAND and GRAVEL',
    'ORGANIC SAND': 'Organic SAND',
    'SILTY ORGANIC SAND': 'Silty SAND',
    'GRAVELLY ORGANIC SAND': 'Gravelly SAND',
    'COBBLY ORGANIC SAND': 'Cobbly SAND',
    'BOULDERY ORGANIC SAND': 'Bouldery SAND',
    GRAVEL: 'GRAVEL',
    'CLAYEY GRAVEL': 'Clayey GRAVEL',
    'SILTY GRAVEL': 'Silty GRAVEL',
    'SANDY GRAVEL': 'Sandy GRAVEL',
    'ORGANIC GRAVEL': 'Organic GRAVEL',
    'COBBLY GRAVEL': 'Cobbly GRAVEL',
    'BOULDERY GRAVEL': 'Bouldery GRAVEL',
    'CLAYEY SANDY GRAVEL': 'Clayey GRAVEL',
    'CLAYEY COBBLY GRAVEL': 'Clayey GRAVEL',
    'CLAYEY BOULDERY GRAVEL': 'Clayey GRAVEL',
    'CLAYEY ORGANIC GRAVEL': 'Clayey GRAVEL',
    'CLAYEY SANDY ORGANIC GRAVEL': 'Clayey GRAVEL',
    'SILTY SANDY GRAVEL': 'Silty GRAVEL',
    'SILTY COBBLY GRAVEL': 'Silty GRAVEL',
    'SILTY BOULDERY GRAVEL': 'Silty GRAVEL',
    'SILTY ORGANIC GRAVEL': 'Silty GRAVEL',
    'SILTY ORGANIC SANDY GRAVEL': 'Silty GRAVEL',
    'SANDY COBBLY GRAVEL': 'Sandy GRAVEL',
    'SANDY BOULDERY GRAVEL': 'Sandy GRAVEL',
    'SANDY ORGANIC GRAVEL': 'Sandy GRAVEL',
    'SILTY SANDY COBBLY GRAVEL': 'Silty GRAVEL',
    PEAT: 'PEAT',
    'CLAYEY PEAT': 'Clayey PEAT',
    'SILTY PEAT': 'Silty PEAT',
    'SANDY PEAT': 'Sandy PEAT',
    'GRAVELLY PEAT': 'Gravelly PEAT',
    'COBBLY PEAT': 'Cobbly PEAT',
    'CLAYEY SANDY PEAT': 'Clayey PEAT',
    'CLAYEY GRAVELLY PEAT': 'Clayey PEAT',
    'SILTY SANDY PEAT': 'Silty PEAT',
    'SILTY SANDY GRAVELLY PEAT': 'Silty PEAT',
    'SANDY GRAVELLY PEAT': 'Sandy PEAT',
    COBBLES: 'COBBLES',
    'CLAYEY COBBLES': 'Clayey COBBLES',
    'SILTY COBBLES': 'Silty COBBLES',
    'SANDY COBBLES': 'Sandy COBBLES',
    'GRAVELLY COBBLES': 'Gravelly COBBLES',
    'ORGANIC COBBLES': 'Organic COBBLES',
    'CLAYEY SANDY COBBLES': 'Clayey COBBLES',
    'CLAYEY GRAVELLY COBBLES': 'Clayey COBBLES',
    'SILTY SANDY COBBLES': 'Silty COBBLES',
    'SILTY GRAVELLY COBBLES': 'Silty COBBLES',
    'SILTY ORGANIC COBBLES': 'Silty COBBLES',
    'SILTY GRAVELLY SANDY COBBLES': 'Silty COBBLES',
    'SILTY SANDY ORGANIC COBBLES': 'Silty COBBLES',
    'SILTY SANDY GRAVELLY ORGANIC COBBLES': 'Silty COBBLES',
    'SANDY GRAVELLY COBBLES': 'Sandy COBBLES',
    'SANDY ORGANIC COBBLES': 'Sandy COBBLES',
    'GRAVELLY ORGANIC COBBLES': 'Gravelly COBBLES',
    'COBBLES AND BOULDERS': 'COBBLES and BOULDERS',
    BOULDERS: 'BOULDERS',
    'GRAVELLY COBBLY BOULDERS': 'Gravelly BOULDERS',
    MUDSTONE: 'MUDSTONE',
    SILTSTONE: 'SILTSTONE',
    SANDSTONE: 'SANDSTONE',
    LIMESTONE: 'LIMESTONE',
    CHALK: 'CHALK',
    COAL: 'COAL',
    BRECCIA: 'BRECCIA',
    CONGLOMERATE: 'CONGLOMERATE',
    'FINE GRAINED IGNEOUS': 'Igneous ROCK',
    'MEDIUM GRAINED IGNEOUS': 'Igneous ROCK',
    'COURSE GRAINED IGNEOUS': 'Igneous ROCK',
    'FINE GRAINED METAMORPHIC': 'Metamorphic ROCK',
    'MEDIUM GRAINED METAMORPHIC': 'Metamorphic ROCK',
    'COURSE GRAINED METAMORPHIC': 'Metamorphic ROCK',
    'PYROCLASTIC (VOLCANIC ASH)': 'ROCK',
    'GYPSUM-ROCKSALT': 'Gypsum',
    SHALE: 'Shale',
    VOID: 'Void',
    'NO RECOVERY': 'No Rec',
    UNDETERMINED: 'Undetermined',
    WOOD: 'Wood',
};
const SOIL_TYPE_AGS_ES = {
    'CAPA SUPERFICIAL': 'TOPSOIL',
    RELLENO: 'MADE GROUND',
    'MATERIAL BITUMINOSO': 'Bitumen',
    'CONCRETO/HORMIGÓN': 'CONCRETE',
    ARCILLA: 'CLAY',
    'ARCILLA LIMOSA': 'Silty CLAY',
    'ARCILLA ARENOSA': 'Sandy CLAY',
    'ARCILLA CON GRAVILLA': 'Gravelly CLAY',
    'ARCILLA CON GRAVA': 'Cobbly CLAY',
    'ARCILLA CON BLOQUES': 'Bouldery CLAY',
    'ARCILLA LIMOSA CON ARENA': 'Silty CLAY',
    'ARCILLA LIMOSA CON GRAVILLA': 'Silty CLAY',
    'ARCILLA LIMOSA CON GRAVAS': 'Silty CLAY',
    'ARCILLA LIMOSA CON BLOQUES': 'Silty CLAY',
    'ARCILLA LIMOSA CON ARENA Y GRAVILLA': 'Silty CLAY',
    'ARCILLA LIMOSA CON ARENA Y GRAVAS': 'Silty CLAY',
    'ARCILLA LIMOSA CON ARENA Y BLOQUES': 'Silty CLAY',
    'ARCILLA LIMOSA CON ARENA, GRAVILLAS Y GRAVAS': 'Silty CLAY',
    'ARCILLA LIMOSA CON ARENA, GRAVILLA Y BLOQUES': 'Silty CLAY',
    'ARCILLA LIMOSA CON ARENA, GRAVILLAS, GRAVAS Y BLOQUES': 'Silty CLAY',
    'ARCILLA LIMOSA ORGÁNICA CON ARENA': 'Silty CLAY',
    'ARCILLA LIMOSA ORGÁNICA CON ARENA Y GRAVILLA': 'Silty CLAY',
    'ARCILLA LIMOSA ORGÁNICA': 'Silty CLAY',
    'ARCILLA ARENOSA CON GRAVILLA': 'Sandy CLAY',
    'ARCILLA ARENOSA CON GRAVAS': 'Sandy CLAY',
    'ARCILLA ARENOSA CON BLOQUES': 'Sandy CLAY',
    'ARCILLA ARENOSA CON GRAVILLA Y GRAVAS': 'Sandy CLAY',
    'ARCILLA ARENOSA CON GRAVILLA Y BLOQUES': 'Sandy CLAY',
    'ARCILLA ARENOSA CON GRAVILLA, GRAVAS Y BLOQUES': 'Sandy CLAY',
    'ARCILLA ARENOSA ORGÁNICA': 'Sandy CLAY',
    'ARCILLA ARENOSA ORGÁNICA CON GRAVAS': 'Sandy CLAY',
    'ARCILLA ORGÁNICA': 'Organic CLAY',
    LIMO: 'SILT',
    'ARCILLA/LIMO': 'CLAY SILT',
    'LIMO ARENOSO': 'Sandy SILT',
    'LIMO CON GRAVILLA': 'Gravelly SILT',
    'LIMO ORGÁNICO': 'Organic SILT',
    'LIMO ARENOSO CON GRAVILLAS': 'Sandy SILT',
    'LIMO ARCILLO-LIMOSO ORGÁNICO CON GRAVILLAS Y GRAVAS': 'Clayey SILT',
    'LIMO ARENOSO CON GRAVAS': 'Sandy SILT',
    'LIMO ARENOSO CON BLOQUES': 'Sandy SILT',
    'LIMO ARENOSO ORGÁNICO': 'Sandy SILT',
    'LIMO ARENOSO ORGÁNICO CON GRAVAS': 'Sandy SILT',
    'LIMO ARENOSO CON GRAVILLAS Y GRAVAS': 'Sandy SILT',
    'LIMO ARENOSO ORGÁNICO CON GRAVILLAS Y GRAVAS': 'Sandy SILT',
    'LIMO CON GRAVILLA Y GRAVA': 'Gravelly SILT',
    'LIMO CON GRAVILLA Y BLOQUES': 'Gravelly SILT',
    'LIMO ORGÁNICO CON GRAVILLAS': 'Gravelly SILT',
    'LIMO ORGÁNICO CON GRAVILLAS Y GRAVAS': 'Gravelly SILT',
    'LIMO CON GRAVAS': 'Cobbly SILT',
    'LIMO CON GRAVAS Y BLOQUES': 'Cobbly SILT',
    'LIMO ORGÁNICO CON GRAVAS': 'Cobbly SILT',
    'LIMO CON BLOQUES': 'Bouldery SILT',
    ARENA: 'SAND',
    'ARENA ARCILLOSA': 'Clayey SAND',
    'ARENA LIMOSA': 'Silty SAND',
    'ARENA CON GRAVILLA': 'Gravelly SAND',
    'ARENA CON GRAVA': 'Cobbly SAND',
    'ARENA CON BLOQUES': 'Bouldery SAND',
    'ARENA ARCILLOSA CON GRAVILLA': 'Clayey SAND',
    'ARENA ARCILLOSA CON GRAVILLA Y GRAVA': 'Clayey SAND',
    'ARENA LIMOSA CON GRAVILLA': 'Silty SAND',
    'ARENA LIMOSA CON GRAVILLA Y GRAVA': 'Silty SAND',
    'ARENA LIMOSA CON GRAVILLA, GRAVA Y BLOQUES': 'Silty SAND',
    'ARENA CON GRAVILLA Y GRAVA': 'Gravelly SAND',
    'ARENA CON GRAVILLA, GRAVA  Y BLOQUES': 'Gravelly SAND',
    'ARENA CON GRAVILLA Y BLOQUES': 'Gravelly SAND',
    'ARENA CON GRAVAS Y BLOQUES': 'Cobbly SAND',
    'ARENA Y GRAVA': 'SAND and GRAVEL',
    'ARENA ORGÁNICA': 'Organic SAND',
    'ARENA LIMOSA ORGÁNICA': 'Silty SAND',
    'ARENA ORGÁNICA CON GRAVILLA': 'Gravelly SAND',
    'ARENA ORGÁNICA CON GRAVA': 'Cobbly SAND',
    'ARENA ORGÁNICA CON BLOQUES': 'Bouldery SAND',
    GRAVILLA: 'GRAVEL',
    'GRAVILLA ARCILLOSA': 'Clayey GRAVEL',
    'GRAVILLA LIMOSA': 'Silty GRAVEL',
    'GRAVILLA ARENOSA': 'Sandy GRAVEL',
    'GRAVILLA ORGÁNICA': 'Organic GRAVEL',
    'GRAVILLA CON GRAVA': 'Cobbly GRAVEL',
    'GRAVILLA CON BLOQUES': 'Bouldery GRAVEL',
    'GRAVILLA ARCILLOSA CON ARENAS': 'Clayey GRAVEL',
    'GRAVILLA ARCILLOSA CON GRAVAS': 'Clayey GRAVEL',
    'GRAVILLA ARCILLOSA CON BLOQUES': 'Clayey GRAVEL',
    'GRAVILLA ARCILLOSA ORGÁNICA': 'Clayey GRAVEL',
    'GRAVILLA ARCILLOSA ORGÁNICA CON ARENAS': 'Clayey GRAVEL',
    'GRAVILLA LIMOSA CON ARENA': 'Silty GRAVEL',
    'GRAVILLA LIMOSA CON GRAVAS': 'Silty GRAVEL',
    'GRAVILLA LIMOSA CON BLOQUES': 'Silty GRAVEL',
    'GRAVILLA LIMOSA ORGÁNICA': 'Silty GRAVEL',
    'GRAVILLA LIMOSA ORGÁNICA CON ARENA': 'Silty GRAVEL',
    'GRAVILLA CON ARENA Y GRAVAS': 'Sandy GRAVEL',
    'GRAVILLA CON ARENA Y BLOQUES': 'Sandy GRAVEL',
    'GRAVILLA ORGÁNICA CON ARENA': 'Sandy GRAVEL',
    'GRAVILLA LIMOSA CON ARENA Y GRAVA': 'Silty GRAVEL',
    'TURBA/MATERIA ORGÁNICA': 'PEAT',
    'TURBA ARCILLOSA': 'Clayey PEAT',
    'TURBA LIMOSA': 'Silty PEAT',
    'TURBA ARENOSA': 'Sandy PEAT',
    'TURBA CON GRAVILLA': 'Gravelly PEAT',
    'TURBA CON GRAVA': 'Cobbly PEAT',
    'TURBA ARCILLOSA CON ARENA': 'Clayey PEAT',
    'TURBA ARCILLOSA CON GRAVILLA': 'Clayey PEAT',
    'TURBA LIMOSA CON ARENA': 'Silty PEAT',
    'TURBA LIMOSA CON ARENA Y GRAVILLA': 'Silty PEAT',
    'TURBA CON ARENA Y GRAVILLA': 'Sandy PEAT',
    GRAVA: 'COBBLES',
    'GRAVA ARCILLOSA': 'Clayey COBBLES',
    'GRAVA LIMOSA': 'Silty COBBLES',
    'GRAVA ARENOSA': 'Sandy COBBLES',
    'GRAVA CON GRAVILLA': 'Gravelly COBBLES',
    'GRAVA ORGÁNICA': 'Organic COBBLES',
    'GRAVA ARCILLOSA CON ARENA ': 'Clayey COBBLES',
    'GRAVA ARCILLOSA CON GRAVILLA': 'Clayey COBBLES',
    'GRAVA LIMOSA CON ARENA ': 'Silty COBBLES',
    'GRAVA LIMOSA CON GRAVILLA': 'Silty COBBLES',
    'GRAVA LIMOSA ORGÁNICA': 'Silty COBBLES',
    'GRAVA LIMOSA CON ARENA Y GRAVILLA ': 'Silty COBBLES',
    'GRAVA LIMOSA ORGÁNICA CON ARENA': 'Silty COBBLES',
    'GRAVA LIMOSA ORGÁNICA CON ARENA Y GRAVILLA': 'Silty COBBLES',
    'GRAVA CON ARENA Y GRAVILLA': 'Sandy COBBLES',
    'GRAVA ORGÁNICA CON ARENA': 'Sandy COBBLES',
    'GRAVA ORGÁNICA CON GRAVILLA': 'Gravelly COBBLES',
    'GRAVAS Y BLOQUES': 'COBBLES and BOULDERS',
    BLOQUES: 'BOULDERS',
    'BLOQUES CON GRAVILLA Y GRAVA': 'Gravelly BOULDERS',
    LUTITA: 'MUDSTONE',
    LIMOLITA: 'SILTSTONE',
    ARENISCA: 'SANDSTONE',
    CALIZA: 'LIMESTONE',
    'CRETA/GIS': 'CHALK',
    CARBÓN: 'COAL',
    BRECHA: 'BRECCIA',
    CONGLOMERADO: 'CONGLOMERATE',
    'ÍGNEA DE GRANO FINO': 'Igneous ROCK',
    'ÍGNEA DE GRANO MEDIO': 'Igneous ROCK',
    'ÍGNEA DE GRANO GRUESO': 'Igneous ROCK',
    'METAMÓRFICA DE GRANO FINO': 'Metamorphic ROCK',
    'METAMÓRFICA DE GRANO MEDIO': 'Metamorphic ROCK',
    'METAMÓRFICA DE GRANO GRUSO': 'Metamorphic ROCK',
    PIROCLASTOS: 'ROCK',
    YESO: 'Gypsum',
    ESQUISTO: 'Shale',
    'VACÍO/HUECO': 'Void',
    'SIN RECUPERACIÓN': 'No Rec',
    INDETERMINADO: 'Undetermined',
    MADERA: 'Wood',
};
const SOIL_TYPE_AGS_ICON_NAME = {
    TOPSOIL: 'E4',
    'MADE GROUND': 'E4',
    CLAY: 'E7',
    'Silty CLAY': 'E8',
    'CLAY SILT': 'E8-Limon argileux',
    'Sandy CLAY': 'E9',
    SILT: 'E35',
    'Organic CLAY': 'E99-Argile Tourbeuse',
    'Sandy SILT': 'E58-Limon sableux',
    'Clayey SILT': 'E8-Limon argileux',
    'Clayey SAND': 'E9-Sable argileux',
    'Gravelly SAND': 'E59',
    'SAND and GRAVEL': 'E59',
    'Organic SAND': 'E101-Sable tourbeux',
    'Clayey GRAVEL': 'E78',
    'Sandy GRAVEL': 'E59-Gravier sableux',
    'Clayey PEAT': 'E99',
    'Silty PEAT': 'E100',
    'Sandy PEAT': 'E101',
    ROCK: 'E143',
    SAND: 'E56',
    'Silty SAND': 'E58',
    'Cobbly SAND': 'E60',
    'Bouldery SAND': 'E61',
    GRAVEL: 'E77',
    'Silty GRAVEL': 'E79',
    'Cobbly GRAVEL': 'E82',
    'Bouldery GRAVEL': 'E83',
    PEAT: 'E98',
    'Gravelly PEAT': 'E102',
    'Cobbly PEAT': 'E103',
    COBBLES: 'E109',
    'Clayey COBBLES': 'E110',
    'Silty COBBLES': 'E111',
    'Sandy COBBLES': 'E112',
    'Organic COBBLES': 'E114',
    'COBBLES and BOULDERS': 'E126',
    BOULDERS: 'E127',
    'Gravelly BOULDERS': 'E128',
    MUDSTONE: 'E129',
    SILTSTONE: 'E130',
    LIMESTONE: 'E132',
    CHALK: 'E133',
    BRECCIA: 'E135',
    CONGLOMERATE: 'E136',
    'Igneous ROCK': 'E137',
    'Metamorphic ROCK': 'E140',
    Gypsum: 'E144',
    Shale: 'E145',
    'Gravelly CLAY': 'E78-Argile Graveleuse',
    'Cobbly CLAY': 'E110-Argile à Galets',
    'Bouldery CLAY': 'E150',
    'Gravelly SILT': 'E79-Limon graveleux',
    'Organic SILT': 'E100-Limon tourbeux',
    'Cobbly SILT': 'E52',
    'Bouldery SILT': 'E55',
    'Organic GRAVEL': 'E102-Gravier tourbeux',
    'Gravelly COBBLES': 'E82-Galers graveleux',
    SANDSTONE: 'E131-Grès',
};
const SOIL_TYPE_AGS_SBT_EN = {
    'ORGANIC SOILS : PEAT': 'PEAT',
    'SILTY CLAY TO CLAY': 'CLAY',
    'SILT MIXTURES: CLAYEY SILT TO SILTY CLAY': 'Clayey SILT',
    'SAND MIXTURES: SILTY SAND TO SANDY SILT': 'SILT',
    'SANDS: CLEAN SAND TO SILTY SAND': 'SAND',
    'GRAVELLY SAND TO DENSE SAND': 'Gravelly SAND',
};
const SOIL_TYPE_AGS_SBT_FR = {
    'SOLS ORGANIQUES: TOURBE': 'PEAT',
    'ARGILE ET ARGILE LIMONEUSE': 'CLAY',
    'MÉLANGES LIMONEUX: LIMON ARGILEUX À ARGILE LIMONEUSE': 'Clayey SILT',
    'MÉLANGES SABLEUX: LIMON SABLEUX À SABLE LIMONEUX': 'SILT',
    'SABLE: SABLE PROPRE À SABLE LIMONEUX': 'SAND',
    'SABLE GRAVELEUX À SABLE DENSE': 'Gravelly SAND',
};
//!\ DO NOT CHANGE THE ORDER OF THE FIELDS (see spec tests)
const SOIL_COMPACTNESS_EN = {
    SAND: {
        'Very Loose': 'Very Loose',
        Loose: 'Loose',
        'Very Dense': 'Very Dense',
        'Medium Dense': 'Medium Dense',
        Dense: 'Dense',
    },
    CLAY: {
        'Very Soft': 'Very Soft',
        Soft: 'Soft',
        Firm: 'Firm',
        'Very Stiff': 'Very Stiff',
        Stiff: 'Stiff',
        'Very hard': 'Very hard',
        Hard: 'Hard',
    },
    ROCK: {
        'Residual Soil': 'Residual Soil',
        'Completely Weathered': 'Completely Weathered',
        'Highly Weathered': 'Highly Weathered',
        'Moderately Weathered': 'Moderately Weathered',
        'Slightly Weathered': 'Slightly Weathered',
        Unweathered: 'Unweathered',
        Fresh: 'Unweathered',
    },
};
//!\ DO NOT CHANGE THE ORDER OF THE FIELDS (see spec tests)
const SOIL_COMPACTNESS_FR = {
    SABLE: {
        'Très lâche': 'Very Loose',
        Lâche: 'Loose',
        'Très Dense': 'Very Dense',
        'Moyennement dense': 'Medium Dense',
        Dense: 'Dense',
    },
    ARGILE: {
        'Très molle': 'Very Soft',
        Molle: 'Soft',
        'Mi-consistante': 'Firm',
        'Très Raide': 'Very Stiff',
        Raide: 'Stiff',
        'Très Dure': 'Very hard',
        Dure: 'Hard',
    },
    ROCHE: {
        'Sol résiduel': 'Residual Soil',
        'Complètement altérée': 'Completely Weathered',
        'Très altérée': 'Highly Weathered',
        'Moyennement altérée': 'Moderately Weathered',
        'Peu Altérée': 'Slightly Weathered',
        Saine: 'Unweathered',
    },
};
//!\ DO NOT CHANGE THE ORDER OF THE FIELDS (see spec tests)
const SOIL_COMPACTNESS_ES = {
    ARENA: {
        'Muy suelta': 'Very Loose',
        Suelta: 'Loose',
        'Muy densa': 'Very Dense',
        Media: 'Medium Dense',
        Densa: 'Dense',
    },
    ARCILLA: {
        'Muy blanda': 'Very Soft',
        Blanda: 'Soft',
        Media: 'Firm',
        'Muy firme': 'Very Stiff',
        Firme: 'Stiff',
        'Muy dura': 'Very hard',
        Dura: 'Hard',
    },
    ROCA: {
        'Suelo residual': 'Residual Soil',
        'Completamente meteorizada': 'Completely Weathered',
        'Muy meteorizada': 'Highly Weathered',
        'Moderamente meteorizada': 'Moderately Weathered',
        'Ligeramente meteorizada': 'Slightly Weathered',
        Sana: 'Unweathered',
    },
};
class SoilTypeUtilsService {
    keywordSoillibType;
    soilTypeString;
    keywordSoillibCompactness;
    constructor() {
        const types = Object.keys(SOIL_TYPE_AGS_EN)
            .reverse()
            .concat(Object.keys(SOIL_TYPE_AGS_FR).reverse())
            .concat(Object.keys(SOIL_TYPE_AGS_ES).reverse());
        const soilTypes = new Map()
            .set(false, types)
            .set(true, types
            .concat(Object.keys(SOIL_TYPE_AGS_SBT_EN).reverse())
            .concat(Object.keys(SOIL_TYPE_AGS_SBT_FR).reverse()));
        this.soilTypeString = new Map();
        soilTypes.forEach((value, key) => {
            this.soilTypeString.set(key, this.soilTypeRegex(value));
        });
        this.keywordSoillibType = new Map()
            .set(false, {
            ...SOIL_TYPE_AGS_EN,
            ...SOIL_TYPE_AGS_FR,
            ...SOIL_TYPE_AGS_ES,
        })
            .set(true, {
            ...SOIL_TYPE_AGS_SBT_EN,
            ...SOIL_TYPE_AGS_SBT_FR,
            ...SOIL_TYPE_AGS_EN,
            ...SOIL_TYPE_AGS_FR,
            ...SOIL_TYPE_AGS_ES,
        });
        this.keywordSoillibCompactness = {
            ...SOIL_COMPACTNESS_EN,
            ...SOIL_COMPACTNESS_FR,
            ...SOIL_COMPACTNESS_ES,
        };
    }
    parseSoilTypes(data, isSBT) {
        return data.map(itemData => ({
            ...itemData,
            calculated_soil: this.parseSoilType(itemData.geo_soil, isSBT),
        }));
    }
    parseSoilCompactnesses(data) {
        return data.map(itemData => ({
            ...itemData,
            calculated_compactness: this.parseSoilCompactness(itemData.geotechnical_engineer_description),
        }));
    }
    parseSoilType(geoSoil, isSBT) {
        let soilDesc;
        if (geoSoil) {
            const regexp = new RegExp(this.soilTypeString.get(isSBT), 'i');
            soilDesc = geoSoil.match(regexp)?.find(() => true);
        }
        else {
            soilDesc = null;
        }
        return soilDesc ? this.getCalculatedSoilTypeFromAGS(soilDesc, isSBT) : null;
    }
    parseSoilCompactness(description) {
        let soilCompactness;
        if (description) {
            const soilCompactnesses = this.flatRecords(SOIL_COMPACTNESS_EN)
                .concat(this.flatRecords(SOIL_COMPACTNESS_FR))
                .concat(this.flatRecords(SOIL_COMPACTNESS_ES));
            soilCompactness = soilCompactnesses.find(value => {
                const regexp = new RegExp(this.compactnessRegex(value), 'i');
                const matches = description.match(regexp);
                if (matches && matches.length === 9) {
                    return !!(matches[1] && matches[3]) || !!(matches[6] && matches[8]);
                }
                else {
                    return false;
                }
            });
        }
        else {
            soilCompactness = null;
        }
        return soilCompactness
            ? this.getCalculatedSoilCompactness(soilCompactness[1], soilCompactness[0])
            : null;
    }
    getCalculatedSoilTypeFromAGS(soilDesc, isSBT) {
        return ((soilDesc
            ? this.keywordSoillibType.get(isSBT)[soilDesc.toUpperCase()]
            : null) ?? null);
    }
    getCalculatedSoilCompactness(soilDesc, soilType) {
        const candidates = [];
        for (const type of Object.keys(this.keywordSoillibCompactness)) {
            candidates.push(...Object.keys(this.keywordSoillibCompactness[type])
                .filter(desc => soilType.toUpperCase() === type.toUpperCase() &&
                soilDesc.toUpperCase() === desc.toUpperCase())
                .map(desc => this.keywordSoillibCompactness[type][desc]));
        }
        if (candidates.length === 1) {
            return candidates[0];
        }
        else {
            return null;
        }
    }
    getSoilPattern(type) {
        if (SOIL_TYPE_AGS_ICON_NAME[type]) {
            return this.getAGSPattern(SOIL_TYPE_AGS_ICON_NAME[type]);
        }
        else if (type === 'none') {
            return 'rgba(255, 255, 255, 0)';
        }
        else {
            return 'rgba(255, 255, 255, 1)';
        }
    }
    getSoilTypeFileName(soilType, isSBT, checkSoilType = false) {
        const calculatedSoilType = checkSoilType
            ? this.getCalculatedSoilTypeFromAGS(soilType, isSBT)
            : soilType;
        if (calculatedSoilType != null) {
            const name = SOIL_TYPE_AGS_ICON_NAME[calculatedSoilType];
            return name != null ? `${name}.png` : null;
        }
        return null;
    }
    getGeosoilFromIc(ic, lang) {
        let soilTypes;
        switch (lang) {
            case 'fr':
                soilTypes = SOIL_TYPE_AGS_SBT_FR;
                break;
            case 'en':
            default:
                soilTypes = SOIL_TYPE_AGS_SBT_EN;
                break;
        }
        const reversedTypes = new Map();
        const typeDescriptions = Object.keys(soilTypes);
        for (const typeDescription of typeDescriptions) {
            reversedTypes.set(soilTypes[typeDescription], typeDescription);
        }
        const zone = getZone(ic);
        if (!zone) {
            return null;
        }
        let typeId;
        switch (zone) {
            case 'ZONE2':
                typeId = 'PEAT';
                break;
            case 'ZONE3':
                typeId = 'CLAY';
                break;
            case 'ZONE4':
                typeId = 'Clayey SILT';
                break;
            case 'ZONE5':
                typeId = 'SILT';
                break;
            case 'ZONE6':
                typeId = 'SAND';
                break;
            case 'ZONE7':
                typeId = 'Gravelly SAND';
                break;
        }
        return reversedTypes.get(typeId);
    }
    getAGSPattern(name) {
        return {
            pattern: {
                image: 'assets/ags-types/' + name + '.png',
                width: 110,
                height: 110,
            },
        };
    }
    flatRecords = (rec) => {
        const out = [];
        for (const s1 of Object.keys(rec)) {
            for (const s2 of Object.keys(rec[s1])) {
                out.push([s1, s2]);
            }
        }
        return out;
    };
    soilTypeRegex = (value) => value.map(r => this.wordRegex(r)).join('|');
    compactnessRegex = (compactnessRecord) => {
        return this.combinations(compactnessRecord)
            .map(combination => combination.map(r => this.wordRegex(r)).join('(.*)'))
            .map(r => `(${r})`)
            .join('|');
    };
    wordRegex = (str) => '(\\b' + str + '\\b)';
    combinations = ([first, second]) => [
        [first, second],
        [second, first],
    ];
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilTypeUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilTypeUtilsService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SoilTypeUtilsService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

const labEntitiesColumnsToTitle = {
    depth: 'Depth (m)',
    w: 'w (%)',
    gamma: '&gamma; (kN/m3)',
    gammad: '&gamma;d (kN/m3)',
    phi_prime: '&phi;&prime; (°)',
    c_prime: 'c&prime; (kPa)',
    cu: 'Cu (kPa)',
    ll: 'LL (%)',
    pl_maju: 'PL (%)',
    pl_minu: 'Pl (%)',
    gravel: 'Gravel',
    sand: 'Sand',
    silt: 'Silt',
    clay: 'Clay',
    eo: 'e0',
    cc: 'Cc',
    cs: 'Cs',
    cv: 'Cv (&#13217;/yr)',
    pc: 'Pc (kPa)',
    kv: 'kv (m/s)',
    kh: 'kh (m/s)',
    ucs: 'UCS (MPa)',
    plil: 'PointLoadIndexIs (MPa)',
    e: 'E (MPa)',
    ph: 'pH',
    caco3: 'CaCO3 (%)',
    organic: 'Organic (%)',
};
const labColumnsToTitle = {
    depth: 'Depth (m)',
    lab_w: 'w (%)',
    lab_gamma: '&gamma; (kN/m3)',
    lab_gammad: '&gamma;d (kN/m3)',
    lab_phi_prime: '&phi;&prime; (°)',
    lab_c_prime: 'c&prime; (kPa)',
    lab_cu: 'Cu (kPa)',
    lab_ll: 'LL (%)',
    lab_pl_maju: 'PL (%)',
    lab_pl_minu: 'Pl (%)',
    lab_gravel: 'Gravel',
    lab_sand: 'Sand',
    lab_silt: 'Silt',
    lab_clay: 'Clay',
    lab_eo: 'e0',
    lab_cc: 'Cc',
    lab_cs: 'Cs',
    lab_cv: 'Cv (&#13217;/yr)',
    lab_pc: 'Pc (kPa)',
    lab_kv: 'kv (m/s)',
    lab_kh: 'kh (m/s)',
    lab_ucs: 'UCS (MPa)',
    lab_plil: 'PointLoadIndexIs (MPa)',
    lab_e: 'E (MPa)',
    lab_ph: 'pH',
    lab_caco3: 'CaCO3 (%)',
    lab_organic: 'Organic (%)',
};
const getLabColumnTitle = (param) => labColumnsToTitle[param] || null;
const getLabParameters = () => Object.keys(labColumnsToTitle).filter(value => value !== 'depth');

var axisId;
(function (axisId) {
    axisId["PRESSURE_MPA"] = "MPa";
    axisId["PRESSURE_KPA"] = "kPa";
    axisId["PERCENTAGE"] = "%";
    axisId["BLOW"] = "Blowcount";
    axisId["DEGREE"] = "\u00B0c";
    axisId["DENSITY"] = "kN/m3";
    axisId["PERMEABILITY"] = "m/s";
    axisId["CONSOLIDATION"] = "m2/yr";
    axisId["UNKNOWN"] = "unknown";
    axisId["N_A"] = "";
})(axisId || (axisId = {}));
var SelectStatus;
(function (SelectStatus) {
    SelectStatus["SELECTED"] = "selected";
    SelectStatus["UNSELECTED"] = "unselected";
    SelectStatus["DEACTIVATED"] = "deactivated";
})(SelectStatus || (SelectStatus = {}));
var Colors;
(function (Colors) {
    Colors["GREEN"] = "#7FFF00";
    Colors["ORANGE"] = "#FFD700";
    Colors["RED"] = "#ff0000";
})(Colors || (Colors = {}));
var Zoom;
(function (Zoom) {
    Zoom[Zoom["MAX"] = 22] = "MAX";
    Zoom[Zoom["MIN"] = 4] = "MIN";
})(Zoom || (Zoom = {}));
var BottomNavHeight;
(function (BottomNavHeight) {
    BottomNavHeight["TOP"] = "calc(100vh - 64px)";
    BottomNavHeight["MIDDLE"] = "55vh";
    BottomNavHeight["BOTTOM"] = "5px";
})(BottomNavHeight || (BottomNavHeight = {}));
var AGS4;
(function (AGS4) {
    AGS4["HEADING"] = "HEADING";
    AGS4["DATA"] = "DATA";
})(AGS4 || (AGS4 = {}));
var GEOL;
(function (GEOL) {
    GEOL["ID"] = "LOCA_ID";
    GEOL["TOP_STRATUM"] = "GEOL_TOP";
    GEOL["BOTTOM_STRATUM"] = "GEOL_BASE";
    GEOL["SOIL_TYPE"] = "GEOL_DESC";
})(GEOL || (GEOL = {}));
var SCPP;
(function (SCPP) {
    SCPP["ID"] = "LOCA_ID";
    SCPP["TOP_STRATUM"] = "SCPP_TOP";
    SCPP["BOTTOM_STRATUM"] = "SCPP_BASE";
    SCPP["SOIL_TYPE"] = "SCPP_CSBT";
})(SCPP || (SCPP = {}));

const bhTypeToParams = {
    PRESSIO: ['pl', 'pl_star', 'pf', 'em'],
    CPT: ['qc', 'f', 'fs', 'rf', 'u2', 'ic', 'icRolling', 'gamma'],
    'CPT-HK': [
        'qc',
        'fs',
        'u2',
        'uo',
        'i',
        'rf',
        'qt',
        'qn',
        'qe',
        'soilfr',
        'soilbq',
        'ic',
        'icRolling',
        'gamma',
    ],
    DESTRUCTIF: ['n', 'n_1_60', 'spt_su_coefficient'],
    CAROTTE: [
        'n',
        'n_1_60',
        'rqd',
        'scr',
        'tcr',
        'cu_insitu',
        'spt_su_coefficient',
    ],
    SOIL_CUTTING: [
        'toit',
        'base',
        'pl',
        'pl_star',
        'pf',
        'em',
        'qc',
        'f',
        'rf',
        'n',
        'n_1_60',
        'rqd',
        'scr',
        'tcr',
        'u2',
        'uo',
        'i',
        'fs',
        'qt',
        'qn',
        'qe',
        'soilfr',
        'soilbq',
    ],
};
const bhTypeToSelectableParams = {
    CPT: ['ic', 'icRolling'],
    'CPT-HK': ['ic', 'icRolling'],
};

function getTechniqueColumnTitle(columnName, isImport = false) {
    switch (columnName) {
        case 'name':
            return 'Name';
        case 'type':
            return 'Type';
        case 'depth':
            return isImport
                ? 'Depth (m)'
                : '<span title="Bottom of stratum"> Depth (m)</span>';
        case 'toit':
            return 'toit (m)';
        case 'base':
            return 'base (m)';
        case 'pl':
            return 'pl (MPa)';
        case 'pl_star':
            return 'pl* (MPa)';
        case 'pf':
            return 'pf (MPa)';
        case 'em':
            return 'Em (MPa)';
        case 'qc':
            return 'qc (MPa)';
        case 'f':
            return 'f (MPa)';
        case 'rf':
            return 'Rf (%)';
        case 'u2':
            return 'u2 (kPa)';
        case 'uo':
            return 'uo (MPa)';
        case 'n':
            return isImport
                ? 'N (Blowcount)'
                : `<div style="cursor:help; display: flex; align-items: center;" title="Values of N (blowcount) are not considered in the correlations. Only N1.60 is considered in the correlations">N (Blowcount)&nbsp;<i class="material-icons">help</i></div>`;
        case 'n_1_60':
            return isImport ? 'N_1.60' : 'N <sub>1.60</sub>';
        case 'spt_su_coefficient':
            return '<div style= "cursor:help; display: flex; align-items: center;" title="Used for correlation data, usual values are Su/N = 5 to 7">S<sub>u</sub>&nbsp;coefficient (Stroud correlation)&nbsp;<i class="material-icons">help</i> </div>';
        case 'rqd':
            return 'RQD (%)';
        case 'scr':
            return 'SCR (%)';
        case 'tcr':
            return 'TCR (%)';
        case 'fs':
            return 'fs (kPa)';
        case 'i':
            return 'I (°)';
        case 'qt':
            return 'qt (MPa)';
        case 'qn':
            return 'qn (MPa)';
        case 'qe':
            return 'qe (MPa)';
        case 'soilfr':
            return 'soilfr';
        case 'soilbq':
            return 'soilbq';
        case 'cu_insitu':
            return 'Cu (kPa)';
        case 'geo_soil':
            return isImport
                ? 'Soil description'
                : '<div style= "cursor:help; display: flex; align-items: center;" title="Main type word in UPPERCASE, other words in lowercase">Soil description <i class="material-icons">help</i> </div>';
        case 'calculated_soil':
            return 'Soil’Lib defined stratigraphy';
        case 'ic':
            return 'Ic';
        case 'icRolling':
            return 'Ic rolling average';
        case 'geotechnical_engineer_description':
            return isImport
                ? 'Geotechnical engineer description'
                : '<div style= "cursor:help; display: flex; align-items: center;" title="Main type word in UPPERCASE, other words in lowercase">Geotechnical engineer description <i class="material-icons">help</i> </div>';
        case 'calculated_compactness':
            return 'Soil’Lib defined compactness';
        case 'gamma':
            return 'ϒ (kN/m³)';
        default:
            return null;
    }
}
function getYaxisParams(id) {
    switch (id) {
        case axisId.PRESSURE_MPA:
            return [
                'pl',
                'pl_star',
                'pf',
                'em',
                'qc',
                'f',
                'uo',
                'qt',
                'qn',
                'qe',
                'ucs',
                'plil',
                'e',
            ];
        case axisId.PRESSURE_KPA:
            return ['fs', 'u2', 'pc', 'cu', 'cu_insitu', 'c_prime'];
        case axisId.PERCENTAGE:
            return [
                'rf',
                'rqd',
                'scr',
                'tcr',
                'w',
                'll',
                'pl_maju',
                'pl_minu',
                'caco3',
                'organic',
            ];
        case axisId.BLOW:
            return ['n'];
        case axisId.DEGREE:
            return ['i', 'phi_prime'];
        case axisId.DENSITY:
            return ['gamma', 'gammad'];
        case axisId.CONSOLIDATION:
            return ['cv'];
        case axisId.PERMEABILITY:
            return ['kv', 'kh'];
        case axisId.UNKNOWN:
            return [
                'soilfr',
                'soilbq',
                'gravel',
                'sand',
                'silt',
                'clay',
                'eo',
                'cc',
                'cs',
                'ph',
            ];
        case axisId.N_A:
            return ['n_1_60'];
        default:
            return [];
    }
}
function getChartTypeByPara(parameter) {
    switch (parameter) {
        case 'n':
        case 'n_1_60':
        case 'pl':
        case 'pf':
        case 'pl_star':
        case 'em':
        case 'cu':
        case 'cu_insitu':
            return { type: 'scatter', lineWidth: 0, showMarker: true };
        default:
            return { type: 'line', lineWidth: 1, showMarker: false };
    }
}
function getTechniqueAvailableParameters(bhType, withSoilType = true, withDepth = true) {
    const types = bhType.split(',');
    let paramsArr = [
        ...(withSoilType
            ? [
                'calculated_soil',
                'calculated_compactness',
                'geo_soil',
                'geotechnical_engineer_description',
            ]
            : []),
        ...types.flatMap(type => bhTypeToParams[type] || []),
    ];
    if (bhType !== 'SOIL_CUTTING' && withDepth) {
        paramsArr.unshift('depth');
    }
    paramsArr = paramsArr.filter((item, pos) => paramsArr.indexOf(item) === pos);
    return paramsArr;
}
function getSelectableColumns(bhType, availableParameters) {
    let selectableParams = [];
    if (availableParameters) {
        selectableParams.push(...availableParameters);
    }
    selectableParams.push(...getAdditionalSelectableParams(bhType));
    selectableParams = selectableParams.filter(col => ![
        'depth',
        'base',
        'toit',
        'geo_soil',
        'calculated_soil',
        'colors',
    ].includes(col));
    return getTechniqueDefaultColumns(bhType, true).filter(({ data }) => typeof data === 'string' ? selectableParams.includes(data) : false);
}
function getAdditionalSelectableParams(bhType) {
    const params = bhType
        .split(',')
        .map(type => bhTypeToSelectableParams[type])
        .filter(value => !!value)
        .reduce((previousValue, currentValue) => [...previousValue, ...currentValue], []);
    return params.filter((item, pos) => params.indexOf(item) === pos);
}
function getTechniqueDefaultColumns(techniqueName, all = false) {
    const stringToColumn = item => ({
        data: item,
        title: getTechniqueColumnTitle(item),
    });
    const availableParams = getTechniqueAvailableParameters(techniqueName);
    if (all) {
        return availableParams.map(stringToColumn);
    }
    else {
        let params;
        const localStorageParams = JSON.parse(localStorage.getItem(techniqueName + '-columns'));
        if (localStorageParams?.every(value => availableParams.includes(value))) {
            params = localStorageParams;
        }
        else {
            params = availableParams;
        }
        return filterSelectedCols(params.map(stringToColumn));
    }
}
function filterSelectedCols(columns) {
    const ns = columns.filter(({ data }) => data === 'n' || data === 'n_1_60').length;
    const pls = columns.filter(({ data }) => data === 'pl' || data === 'pl_star').length;
    if (ns > 1) {
        columns = columns.filter(({ data }) => data !== 'n');
    }
    if (pls > 1) {
        columns = columns.filter(({ data }) => data !== 'pl');
    }
    return columns;
}
function deSerializeColumnNames(columnNames) {
    return columnNames.map(columnName => {
        return { data: columnName, title: getTechniqueColumnTitle(columnName) };
    });
}

function getScaleInfos(scale, dataArr) {
    if (!scale) {
        scale = {
            min: null,
            max: null,
            interval: 0,
        };
    }
    const minArr = dataArr.map(v => v[0]);
    if (scale.min !== null) {
        minArr.push(scale.min);
    }
    if (minArr?.length > 0) {
        scale.min = Math.min.apply(null, minArr);
    }
    const maxArr = dataArr.map(v => v[0]);
    if (scale.max !== null) {
        maxArr.push(scale.max);
    }
    if (maxArr?.length > 0) {
        scale.max = Math.max.apply(null, maxArr);
    }
    return scale;
}
function getDataObject(arr, para, elevation) {
    return {
        data: arr
            .map(item => [
            item[para] === null ? null : Number(item[para]),
            item.depth,
        ])
            .sort((a, b) => a[1] - b[1])
            .filter(data => data[0] !== null),
        elevationData: arr
            .map(item => [
            item[para] === null ? null : Number(item[para]),
            elevation - item.depth,
        ])
            .sort((a, b) => a[1] - b[1])
            .filter(data => data[0] !== null),
    };
}
function getMinPixelWidth(aixPosition, columnWidth) {
    let widthLeft;
    let widthRight;
    Object.values(aixPosition).forEach((element, index) => {
        if (index === 0) {
            widthLeft = element.width;
            widthRight = element.widthR;
        }
        else {
            widthLeft = Math.min(widthLeft, element.width);
            widthRight = Math.min(widthRight, element.widthR);
        }
    });
    return Math.min(3 * columnWidth, Math.max(columnWidth, Math.min(widthLeft, widthRight)));
}
function toCrossSectionDto(crname, paraminfo, originalBhs, projectedBhs) {
    const crossSectionDto = {
        cr_name: crname,
        boreholes: [],
    };
    for (const obh of originalBhs) {
        crossSectionDto.boreholes.push({
            survey_id: obh.id,
            survey_name: obh.name,
            survey_type: obh.type,
            bh_original: true,
            params: [],
        });
    }
    for (const pbh of projectedBhs) {
        crossSectionDto.boreholes.push({
            survey_id: pbh.id,
            survey_name: pbh.name,
            survey_type: pbh.type,
            bh_original: false,
            params: [],
        });
    }
    if (paraminfo) {
        for (const position of Object.keys(paraminfo)) {
            if (paraminfo[position].type) {
                for (const bhid of Object.keys(paraminfo[position].data)) {
                    const dataPerbh = paraminfo[position].data[bhid];
                    let surveyinfo = originalBhs.find(item => item.id === bhid);
                    if (surveyinfo == undefined) {
                        surveyinfo = projectedBhs.find(item => item.id === bhid);
                    }
                    const paraminfos = Object.keys(dataPerbh).map(para => {
                        return {
                            param: para,
                            position: position,
                        };
                    });
                    const existedBh = crossSectionDto.boreholes.find(item => item.survey_id === bhid);
                    if (existedBh) {
                        existedBh.params = existedBh.params.concat(paraminfos);
                    }
                }
            }
        }
    }
    return crossSectionDto;
}

// eslint-disable-next-line no-warning-comments
// TODO: May be better if this table could be defined by data of DB
function allBoreholeTypes() {
    return ['CPT', 'CPT-HK', 'PRESSIO', 'DESTRUCTIF', 'CAROTTE', 'PIEZO', 'PUITS'];
}
function getBoreholeTypeName(types, translation) {
    if (typeof types === 'string') {
        const typesArr = types.split(',');
        const typeNames = typesArr.map(type => TypeToName(type, translation));
        return typeNames.toString();
    }
    else if (Array.isArray(types)) {
        const typeNames = types.map(type => TypeToName(type, translation));
        return typeNames.toString();
    }
    return '';
}
function TypeToName(type, translation) {
    return translation.instant('BOREHOLE_TYPE.' + type);
}
function getBoreholeTypeSymbol(type) {
    switch (type) {
        case 'CPT':
        case 'CPT-HK':
            return 'assets/bhsymbol/cpt.png';
        case 'PRESSIO':
            return 'assets/bhsymbol/pressio.png';
        case 'DESTRUCTIF':
            return 'assets/bhsymbol/destructif.png';
        case 'CAROTTE':
            return 'assets/bhsymbol/carottage.png';
        case 'PIEZO':
            return 'assets/bhsymbol/piezo.png';
        case 'PUITS':
            return 'assets/bhsymbol/puits.png';
        default:
            return '';
    }
}

class SelectParametersDialogComponent {
    dialogRef;
    sourceData;
    fb;
    translationService;
    constructor(dialogRef, sourceData, fb, translationService) {
        this.dialogRef = dialogRef;
        this.sourceData = sourceData;
        this.fb = fb;
        this.translationService = translationService;
    }
    output;
    allLabTestParas;
    labParasDisableMap;
    ColToTitle = labEntitiesColumnsToTitle;
    position;
    selectedInfos;
    selectedTabIndex;
    selectedParameterGroup;
    labTestParasFormControl;
    scaleFormGroup;
    noLabTestData;
    subscription = new Subscription();
    static getSelectedLabParas(dataObject) {
        let selectedLabParas = [];
        if (dataObject) {
            const ids = Object.keys(dataObject);
            if (ids[0]) {
                selectedLabParas = Object.keys(dataObject?.[ids[0]]);
            }
        }
        return selectedLabParas;
    }
    ngOnInit() {
        this.allLabTestParas = Object.keys(labEntitiesColumnsToTitle);
        this.allLabTestParas.shift();
        this.initLabParasDisableMap();
        this.output = {
            left: {
                type: null,
                data: null,
                scale: null,
            },
            right: {
                type: null,
                data: null,
                scale: null,
            },
        };
        this.selectedInfos = {
            left: null,
            right: null,
        };
        this.position = 'left';
        this.selectedTabIndex = 0; // 0:lab Test, 1:in-situ Test
        this.labTestParasFormControl = new FormControl(null);
        this.subscription.add(this.labTestParasFormControl.valueChanges.subscribe(values => {
            if (values) {
                const infos = {
                    survey_ids: this.sourceData?.data
                        ?.filter(item => item.data?.length > 0)
                        .map(item => item.id),
                    lab_parameters: values,
                    position: this.position,
                };
                this.output[this.position].type = 'lab';
                const res = this.getLabTestDataSeries(infos);
                this.output[this.position].data = res.labData;
                this.output[this.position].scale = res.scaleInfo;
                this.getSelectedInfos();
                this.initScaleForm();
            }
        }));
        this.selectedParameterGroup = new FormRecord({});
        this.sourceData?.data?.forEach(item => {
            this.selectedParameterGroup.addControl(item.id, this.fb.control(null));
        });
        this.sourceData.data = this.sourceData?.data?.map(item => {
            const paras = getTechniqueAvailableParameters(item.type);
            paras.splice(paras.indexOf('depth'), 1);
            paras.splice(paras.indexOf('calculated_soil'), 1);
            paras.splice(paras.indexOf('geo_soil'), 1);
            paras.splice(paras.indexOf('calculated_compactness'), 1);
            paras.splice(paras.indexOf('geotechnical_engineer_description'), 1);
            return { ...item, parameters: paras };
        });
        this.subscription.add(this.selectedParameterGroup.valueChanges.subscribe((res) => {
            if (res) {
                const scaleInfo = {};
                const insituData = {};
                let allNull = true;
                for (const id of Object.keys(res)) {
                    const surveyInfo = this.sourceData?.data?.find(item => item.id === id);
                    if (!insituData[id]) {
                        insituData[id] = {};
                    }
                    if (res[id]) {
                        allNull = false;
                    }
                    res[id]?.map(para => {
                        insituData[id][para] = getDataObject(surveyInfo.surveyData, para, surveyInfo.elevation);
                        scaleInfo[para] = getScaleInfos(scaleInfo[para], insituData[id][para].data);
                    });
                }
                if (!allNull) {
                    this.output[this.position].type = 'in-situ';
                    this.output[this.position].data = insituData;
                    this.output[this.position].scale = scaleInfo;
                    this.getSelectedInfos();
                    this.initScaleForm();
                }
            }
        }));
        if (this.sourceData.initSelectorData) {
            this.output = this.sourceData.initSelectorData;
        }
        this.getSelectedInfos();
        this.configFormOptions();
        this.initScaleForm();
    }
    initScaleForm() {
        this.scaleFormGroup = this.fb.group({
            parameters: new FormArray([]),
            minValues: new FormArray([]),
            maxValues: new FormArray([]),
            tickIntervals: new FormArray([]),
        });
        const currentScaleInfo = this.output[this.position].scale;
        if (currentScaleInfo) {
            const controls = this.scaleFormGroup.controls;
            for (const para of Object.keys(currentScaleInfo)) {
                controls.parameters.push(new FormControl(para));
                controls.minValues.push(new FormControl(currentScaleInfo[para].min));
                controls.maxValues.push(new FormControl(currentScaleInfo[para].max));
                controls.tickIntervals.push(new FormControl(currentScaleInfo[para].interval));
            }
        }
        this.subscription.add(this.scaleFormGroup.valueChanges.subscribe(values => {
            const newScaleInfo = {};
            values?.parameters?.forEach((para, index) => {
                newScaleInfo[para] = {
                    min: values?.minValues?.[index],
                    max: values?.maxValues?.[index],
                    interval: values?.tickIntervals?.[index],
                };
            });
            this.output[this.position].scale = newScaleInfo;
        }));
    }
    getSelectedInfos() {
        if (this.output) {
            for (const position of Object.keys(this.output)) {
                if (this.output[position].type === 'lab') {
                    let labParaInfos = '';
                    if (this.output[position]?.data) {
                        labParaInfos = SelectParametersDialogComponent.getSelectedLabParas(this.output[position]?.data)
                            .map(para => labEntitiesColumnsToTitle[para])
                            .join();
                    }
                    this.selectedInfos[position] = '<b>Lab Test:</b> <br>' + labParaInfos;
                }
                else if (this.output[position].type === 'in-situ') {
                    const insituInfo = [];
                    for (const id of Object.keys(this.output[position]?.data)) {
                        const surveyInfo = this.sourceData?.data?.find(item => item.id === id);
                        if (this.output[position]?.data?.[id]) {
                            const paras = Object.keys(this.output[position].data[id]);
                            const paraArr = paras
                                ? paras?.map(p => getTechniqueColumnTitle(p)).join()
                                : '';
                            insituInfo.push(surveyInfo.name + ': ' + paraArr + '<br>');
                        }
                    }
                    this.selectedInfos[position] =
                        '<b>In-situ Test:</b> <br>' + insituInfo.join('');
                }
            }
        }
    }
    getLabTestDataSeries(infos) {
        const scaleInfo = {};
        const labData = {};
        if (infos?.lab_parameters?.length > 0) {
            const paras = infos.lab_parameters;
            this.sourceData.labData?.map((arr) => {
                if (arr?.length > 0) {
                    const surveyId = arr[0].soilsurvey_id;
                    if (infos.survey_ids.includes(surveyId)) {
                        const elevation = this.sourceData.data.find(item => item.id === surveyId)?.elevation;
                        paras.map((para) => {
                            if (!labData[surveyId]) {
                                labData[surveyId] = {};
                            }
                            labData[surveyId][para] = getDataObject(arr, para, elevation);
                            scaleInfo[para] = getScaleInfos(scaleInfo[para], labData[surveyId][para].data);
                        });
                    }
                }
            });
        }
        if (Object.keys(labData).length === 0) {
            this.noLabTestData = true;
        }
        return { labData, scaleInfo };
    }
    getParaName(para) {
        return getTechniqueColumnTitle(para);
    }
    getInsituLabParaName(para, index) {
        const noData = this.scaleFormGroup?.controls?.minValues?.controls[index]?.value == null;
        let paraString = getTechniqueColumnTitle(para) || labEntitiesColumnsToTitle[para];
        if (noData) {
            paraString = paraString + '(no data)';
        }
        return paraString;
    }
    boreholeTypeName(types) {
        return getBoreholeTypeName(types, this.translationService);
    }
    initLabParasDisableMap() {
        this.labParasDisableMap = {};
        this.allLabTestParas.map((para) => {
            this.labParasDisableMap[para] = false;
        });
    }
    configFormOptions() {
        if (this.output) {
            const { data, type } = this.output[this.position];
            this.initLabParasDisableMap();
            switch (type) {
                case 'lab':
                    this.selectedTabIndex = 0;
                    this.initLabTestParasFormControlValue(data);
                    break;
                case 'in-situ':
                    this.selectedTabIndex = 1;
                    this.initSelectedParametersGroupValue(data);
                    break;
            }
            const otherPositions = Object.keys(this.output).filter(p => p !== this.position);
            for (const otherPosition of otherPositions) {
                const { data: otherData, type: otherType } = this.output[otherPosition];
                if (otherType === 'lab') {
                    SelectParametersDialogComponent.getSelectedLabParas(otherData).forEach((para) => (this.labParasDisableMap[para] = true));
                }
            }
        }
    }
    setPosition(position) {
        this.position = position;
        this.configFormOptions();
        this.initScaleForm();
    }
    clear(event, position) {
        event.stopPropagation();
        this.selectedInfos[position] = null;
        this.output[position] = {
            type: null,
            data: null,
            scale: null,
        };
    }
    tabChanged(index) {
        if (index === 0 && this.output) {
            this.initLabParasDisableMap();
            if (this.output[this.position].type === 'in-situ') {
                this.labTestParasFormControl?.setValue(null);
            }
            for (const position of Object.keys(this.output)) {
                const info = this.output[position];
                if (position !== this.position) {
                    if (info.type === 'lab') {
                        const selectedLabParas = SelectParametersDialogComponent.getSelectedLabParas(info.data);
                        selectedLabParas?.map((para) => {
                            this.labParasDisableMap[para] = true;
                        });
                    }
                }
            }
        }
    }
    clearFormControlValue(fc) {
        fc?.setValue(null);
    }
    close() {
        this.dialogRef.close();
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    initLabTestParasFormControlValue(data) {
        const selectedLabParas = SelectParametersDialogComponent.getSelectedLabParas(data);
        this.labTestParasFormControl?.setValue(selectedLabParas, {
            emitEvent: false,
        });
    }
    initSelectedParametersGroupValue(data) {
        if (this.selectedParameterGroup) {
            const selectedInsituParas = {};
            for (const id of Object.keys(data)) {
                selectedInsituParas[id] = Object.keys(data[id]);
            }
            this.selectedParameterGroup.patchValue(selectedInsituParas, {
                emitEvent: false,
            });
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SelectParametersDialogComponent, deps: [{ token: i1$2.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: i2.FormBuilder }, { token: i1$1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: SelectParametersDialogComponent, selector: "ssd-soillib-lib-app-select-parameters-dialog", ngImport: i0, template: "<h1 mat-dialog-title>{{ 'CROSS_SECTION.PLOT_GRAPHS_TITLE' | translate }}</h1>\n<div mat-dialog-content class=\"content-container flex-layout-row flex-gap-5px\">\n  <div class=\"results-container flex-25 flex-layout-column flex-gap-10px\">\n    <mat-card\n      appearance=\"outlined\"\n      [ngClass]=\"{ selected: position === 'left' }\"\n      class=\"flex-50\"\n      (click)=\"setPosition('left')\"\n    >\n      <h4>\n        {{ 'CROSS_SECTION.LEFT' | translate }}\n        <mat-icon\n          style=\"float: right; cursor: pointer\"\n          (click)=\"clear($event, 'left')\"\n          >clear</mat-icon\n        >\n      </h4>\n      <hr />\n      <div class=\"para-infos\">\n        <span [innerHTML]=\"selectedInfos['left']\"></span>\n      </div>\n    </mat-card>\n    <mat-card\n      appearance=\"outlined\"\n      [ngClass]=\"{ selected: position === 'right' }\"\n      class=\"flex-50\"\n      (click)=\"setPosition('right')\"\n    >\n      <h4>\n        {{ 'CROSS_SECTION.RIGHT' | translate }}\n        <mat-icon\n          style=\"float: right; cursor: pointer\"\n          (click)=\"clear($event, 'right')\"\n          >clear</mat-icon\n        >\n      </h4>\n      <hr />\n      <div class=\"para-infos\">\n        <span [innerHTML]=\"selectedInfos['right']\"></span>\n      </div>\n    </mat-card>\n  </div>\n  <div class=\"selector-container flex-55\">\n    <mat-tab-group\n      [(selectedIndex)]=\"selectedTabIndex\"\n      (selectedIndexChange)=\"tabChanged($event)\"\n    >\n      <mat-tab label=\"Lab Test\">\n        <div\n          class=\"flex-layout-row flex-align-space-between--center flex-gap-15px\"\n        >\n          <mat-form-field class=\"flex-50\">\n            <mat-select\n              placeholder=\"Lab Test\"\n              [formControl]=\"labTestParasFormControl\"\n              multiple\n            >\n              <mat-option\n                *ngFor=\"let item of allLabTestParas\"\n                [value]=\"item\"\n                [disabled]=\"labParasDisableMap[item]\"\n              >\n                <span [innerHTML]=\"ColToTitle[item]\"></span>\n              </mat-option>\n            </mat-select>\n          </mat-form-field>\n          <mat-icon\n            class=\"flex\"\n            style=\"cursor: pointer\"\n            (click)=\"clearFormControlValue(labTestParasFormControl)\"\n          >\n            undo\n          </mat-icon>\n        </div>\n        <div class=\"message\" *ngIf=\"noLabTestData\">\n          * {{ 'CROSS_SECTION.NO_DATA_LAB_TEST' | translate }}\n        </div>\n      </mat-tab>\n      <mat-tab label=\"In-situ Test\">\n        <form [formGroup]=\"selectedParameterGroup\">\n          <div\n            class=\"flex-layout-row flex-align-space-between--center flex-gap-15px\"\n            *ngFor=\"let data of sourceData.data\"\n          >\n            <div class=\"flex-40\">\n              {{ data?.name }} ( {{ boreholeTypeName(data?.type) }})\n            </div>\n            <mat-form-field class=\"flex-40\">\n              <mat-select\n                placeholder=\"Parameters\"\n                [formControlName]=\"data?.id\"\n                multiple\n              >\n                <mat-option *ngFor=\"let item of data.parameters\" [value]=\"item\">\n                  <span [innerHTML]=\"getParaName(item)\"></span>\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n            <mat-icon\n              class=\"flex\"\n              style=\"cursor: pointer\"\n              (click)=\"\n                clearFormControlValue(selectedParameterGroup.get(data?.id))\n              \"\n            >\n              undo\n            </mat-icon>\n          </div>\n        </form>\n      </mat-tab>\n    </mat-tab-group>\n  </div>\n  <div class=\"scale-container flex-35\">\n    <div class=\"scale-title\">{{ 'CROSS_SECTION.SCALE' | translate }}</div>\n    <form [formGroup]=\"scaleFormGroup\">\n      <div class=\"flex-layout-row flex-align-space-between flex-gap-5px\">\n        <div\n          class=\"flex-0-1-25 flex-layout-column flex-gap-5px\"\n          formArrayName=\"parameters\"\n          *ngIf=\"scaleFormGroup\"\n        >\n          <mat-form-field\n            *ngFor=\"\n              let para of scaleFormGroup.controls.parameters.controls;\n              let i = index\n            \"\n          >\n            <span\n              [innerHTML]=\"getInsituLabParaName(para?.value, i)\"\n              style=\"white-space: nowrap; font-size: 13px\"\n            ></span>\n            <input\n              matInput\n              placeholder=\"{{ 'CROSS_SECTION.PARAMETER' | translate }}\"\n              autocomplete=\"off\"\n              formControlName=\"{{ i }}\"\n              readonly\n              style=\"display: none\"\n              type=\"text\"\n            />\n          </mat-form-field>\n        </div>\n        <div\n          class=\"flex-0-1-15 flex-layout-column flex-gap-5px\"\n          formArrayName=\"minValues\"\n          *ngIf=\"scaleFormGroup\"\n        >\n          <mat-form-field\n            *ngFor=\"\n              let min of scaleFormGroup.controls.minValues.controls;\n              let i = index\n            \"\n          >\n            <input\n              matInput\n              placeholder=\"Min\"\n              autocomplete=\"off\"\n              formControlName=\"{{ i }}\"\n              type=\"number\"\n            />\n          </mat-form-field>\n        </div>\n        <div\n          class=\"flex-0-1-15 flex-layout-column flex-gap-5px\"\n          formArrayName=\"maxValues\"\n          *ngIf=\"scaleFormGroup\"\n        >\n          <mat-form-field\n            *ngFor=\"\n              let max of scaleFormGroup.controls.maxValues.controls;\n              let i = index\n            \"\n          >\n            <input\n              matInput\n              placeholder=\"Max\"\n              autocomplete=\"off\"\n              formControlName=\"{{ i }}\"\n              type=\"number\"\n            />\n          </mat-form-field>\n        </div>\n        <div\n          class=\"flex-0-1-15 flex-layout-column flex-gap-5px\"\n          formArrayName=\"tickIntervals\"\n          *ngIf=\"scaleFormGroup\"\n        >\n          <mat-form-field\n            *ngFor=\"\n              let min of scaleFormGroup.controls.tickIntervals.controls;\n              let i = index\n            \"\n          >\n            <input\n              matInput\n              placeholder=\"{{ 'CROSS_SECTION.INTERVAL' | translate }}\"\n              autocomplete=\"off\"\n              formControlName=\"{{ i }}\"\n              type=\"number\"\n            />\n          </mat-form-field>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n\n<div mat-dialog-actions class=\"button-container\">\n  <button mat-raised-button (click)=\"close()\">\n    {{ 'GENERAL.CANCEL' | translate }}\n  </button>\n  <button mat-raised-button color=\"warn\" [mat-dialog-close]=\"output\">OK</button>\n</div>\n", styles: [".button-container{float:right}.content-container{min-height:300px}.selector-container,.results-container{padding:10px}.scale-container{margin:0 10px 10px;border-left:gray 1px dashed;padding:10px}.scale-title{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500;color:gray;line-height:48px}.tab-content{padding:10px}.selected{color:#fff;background-color:red}.para-infos{font-size:12px}.message{font-size:10px;color:orange}.flex-0-1-25{flex:0 1 25%;box-sizing:border-box}.flex-0-1-15{flex:0 1 15%;box-sizing:border-box}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i7.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "component", type: i8.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i2.FormArrayName, selector: "[formArrayName]", inputs: ["formArrayName"] }, { kind: "directive", type: i1$2.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$2.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$2.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$2.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i9.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i10.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex", "panelWidth", "hideSingleSelectionIndicator"], exportAs: ["matSelect"] }, { kind: "component", type: i11.MatTab, selector: "mat-tab", inputs: ["disabled"], exportAs: ["matTab"] }, { kind: "component", type: i11.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple", "fitInkBarToContent", "mat-stretch-tabs"], exportAs: ["matTabGroup"] }, { kind: "component", type: i12.MatCard, selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "pipe", type: i1$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SelectParametersDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ssd-soillib-lib-app-select-parameters-dialog', template: "<h1 mat-dialog-title>{{ 'CROSS_SECTION.PLOT_GRAPHS_TITLE' | translate }}</h1>\n<div mat-dialog-content class=\"content-container flex-layout-row flex-gap-5px\">\n  <div class=\"results-container flex-25 flex-layout-column flex-gap-10px\">\n    <mat-card\n      appearance=\"outlined\"\n      [ngClass]=\"{ selected: position === 'left' }\"\n      class=\"flex-50\"\n      (click)=\"setPosition('left')\"\n    >\n      <h4>\n        {{ 'CROSS_SECTION.LEFT' | translate }}\n        <mat-icon\n          style=\"float: right; cursor: pointer\"\n          (click)=\"clear($event, 'left')\"\n          >clear</mat-icon\n        >\n      </h4>\n      <hr />\n      <div class=\"para-infos\">\n        <span [innerHTML]=\"selectedInfos['left']\"></span>\n      </div>\n    </mat-card>\n    <mat-card\n      appearance=\"outlined\"\n      [ngClass]=\"{ selected: position === 'right' }\"\n      class=\"flex-50\"\n      (click)=\"setPosition('right')\"\n    >\n      <h4>\n        {{ 'CROSS_SECTION.RIGHT' | translate }}\n        <mat-icon\n          style=\"float: right; cursor: pointer\"\n          (click)=\"clear($event, 'right')\"\n          >clear</mat-icon\n        >\n      </h4>\n      <hr />\n      <div class=\"para-infos\">\n        <span [innerHTML]=\"selectedInfos['right']\"></span>\n      </div>\n    </mat-card>\n  </div>\n  <div class=\"selector-container flex-55\">\n    <mat-tab-group\n      [(selectedIndex)]=\"selectedTabIndex\"\n      (selectedIndexChange)=\"tabChanged($event)\"\n    >\n      <mat-tab label=\"Lab Test\">\n        <div\n          class=\"flex-layout-row flex-align-space-between--center flex-gap-15px\"\n        >\n          <mat-form-field class=\"flex-50\">\n            <mat-select\n              placeholder=\"Lab Test\"\n              [formControl]=\"labTestParasFormControl\"\n              multiple\n            >\n              <mat-option\n                *ngFor=\"let item of allLabTestParas\"\n                [value]=\"item\"\n                [disabled]=\"labParasDisableMap[item]\"\n              >\n                <span [innerHTML]=\"ColToTitle[item]\"></span>\n              </mat-option>\n            </mat-select>\n          </mat-form-field>\n          <mat-icon\n            class=\"flex\"\n            style=\"cursor: pointer\"\n            (click)=\"clearFormControlValue(labTestParasFormControl)\"\n          >\n            undo\n          </mat-icon>\n        </div>\n        <div class=\"message\" *ngIf=\"noLabTestData\">\n          * {{ 'CROSS_SECTION.NO_DATA_LAB_TEST' | translate }}\n        </div>\n      </mat-tab>\n      <mat-tab label=\"In-situ Test\">\n        <form [formGroup]=\"selectedParameterGroup\">\n          <div\n            class=\"flex-layout-row flex-align-space-between--center flex-gap-15px\"\n            *ngFor=\"let data of sourceData.data\"\n          >\n            <div class=\"flex-40\">\n              {{ data?.name }} ( {{ boreholeTypeName(data?.type) }})\n            </div>\n            <mat-form-field class=\"flex-40\">\n              <mat-select\n                placeholder=\"Parameters\"\n                [formControlName]=\"data?.id\"\n                multiple\n              >\n                <mat-option *ngFor=\"let item of data.parameters\" [value]=\"item\">\n                  <span [innerHTML]=\"getParaName(item)\"></span>\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n            <mat-icon\n              class=\"flex\"\n              style=\"cursor: pointer\"\n              (click)=\"\n                clearFormControlValue(selectedParameterGroup.get(data?.id))\n              \"\n            >\n              undo\n            </mat-icon>\n          </div>\n        </form>\n      </mat-tab>\n    </mat-tab-group>\n  </div>\n  <div class=\"scale-container flex-35\">\n    <div class=\"scale-title\">{{ 'CROSS_SECTION.SCALE' | translate }}</div>\n    <form [formGroup]=\"scaleFormGroup\">\n      <div class=\"flex-layout-row flex-align-space-between flex-gap-5px\">\n        <div\n          class=\"flex-0-1-25 flex-layout-column flex-gap-5px\"\n          formArrayName=\"parameters\"\n          *ngIf=\"scaleFormGroup\"\n        >\n          <mat-form-field\n            *ngFor=\"\n              let para of scaleFormGroup.controls.parameters.controls;\n              let i = index\n            \"\n          >\n            <span\n              [innerHTML]=\"getInsituLabParaName(para?.value, i)\"\n              style=\"white-space: nowrap; font-size: 13px\"\n            ></span>\n            <input\n              matInput\n              placeholder=\"{{ 'CROSS_SECTION.PARAMETER' | translate }}\"\n              autocomplete=\"off\"\n              formControlName=\"{{ i }}\"\n              readonly\n              style=\"display: none\"\n              type=\"text\"\n            />\n          </mat-form-field>\n        </div>\n        <div\n          class=\"flex-0-1-15 flex-layout-column flex-gap-5px\"\n          formArrayName=\"minValues\"\n          *ngIf=\"scaleFormGroup\"\n        >\n          <mat-form-field\n            *ngFor=\"\n              let min of scaleFormGroup.controls.minValues.controls;\n              let i = index\n            \"\n          >\n            <input\n              matInput\n              placeholder=\"Min\"\n              autocomplete=\"off\"\n              formControlName=\"{{ i }}\"\n              type=\"number\"\n            />\n          </mat-form-field>\n        </div>\n        <div\n          class=\"flex-0-1-15 flex-layout-column flex-gap-5px\"\n          formArrayName=\"maxValues\"\n          *ngIf=\"scaleFormGroup\"\n        >\n          <mat-form-field\n            *ngFor=\"\n              let max of scaleFormGroup.controls.maxValues.controls;\n              let i = index\n            \"\n          >\n            <input\n              matInput\n              placeholder=\"Max\"\n              autocomplete=\"off\"\n              formControlName=\"{{ i }}\"\n              type=\"number\"\n            />\n          </mat-form-field>\n        </div>\n        <div\n          class=\"flex-0-1-15 flex-layout-column flex-gap-5px\"\n          formArrayName=\"tickIntervals\"\n          *ngIf=\"scaleFormGroup\"\n        >\n          <mat-form-field\n            *ngFor=\"\n              let min of scaleFormGroup.controls.tickIntervals.controls;\n              let i = index\n            \"\n          >\n            <input\n              matInput\n              placeholder=\"{{ 'CROSS_SECTION.INTERVAL' | translate }}\"\n              autocomplete=\"off\"\n              formControlName=\"{{ i }}\"\n              type=\"number\"\n            />\n          </mat-form-field>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n\n<div mat-dialog-actions class=\"button-container\">\n  <button mat-raised-button (click)=\"close()\">\n    {{ 'GENERAL.CANCEL' | translate }}\n  </button>\n  <button mat-raised-button color=\"warn\" [mat-dialog-close]=\"output\">OK</button>\n</div>\n", styles: [".button-container{float:right}.content-container{min-height:300px}.selector-container,.results-container{padding:10px}.scale-container{margin:0 10px 10px;border-left:gray 1px dashed;padding:10px}.scale-title{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500;color:gray;line-height:48px}.tab-content{padding:10px}.selected{color:#fff;background-color:red}.para-infos{font-size:12px}.message{font-size:10px;color:orange}.flex-0-1-25{flex:0 1 25%;box-sizing:border-box}.flex-0-1-15{flex:0 1 15%;box-sizing:border-box}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i2.FormBuilder }, { type: i1$1.TranslateService }]; } });

function areArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    for (let i = arr1.length; i >= 0; i--) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}
function allValuePositive(arr) {
    for (const point of arr) {
        if (point.low === point.high) {
            return false;
        }
    }
    return true;
}

function getChartMarginTop(selectedParas) {
    const allYaxis = Object.keys(axisId).map(key => axisId[key]);
    const selectedYaxis = [];
    selectedParas.forEach(para => {
        for (const yaxisId of allYaxis) {
            if (getYaxisParams(yaxisId).includes(para)) {
                if (!selectedYaxis.includes(yaxisId)) {
                    selectedYaxis.push(yaxisId);
                }
                break;
            }
        }
    });
    if (selectedYaxis.length) {
        return 60 + selectedYaxis.length * 30;
    }
    else {
        return 60;
    }
}
function addSeriesAndYaxis(chart, para, data, color, curveName) {
    for (const key in axisId) {
        // eslint-disable-next-line no-prototype-builtins
        if (axisId.hasOwnProperty(key)) {
            const id = axisId[key];
            if (getYaxisParams(id).includes(para)) {
                addYaxis(chart, id);
                addSeriesToYAxis(chart, id, para, data, curveName, color);
            }
        }
    }
}
/**
 * Sanitizes the technique column title by removing unnecessary HTML tags and special characters.
 *
 * @param {string} html - The HTML string representing the technique column title.
 * @returns {string} - The sanitized technique column title.
 */
function sanitizeTechniqueColumnTitle(html) {
    // Step 1: Remove <div> tags and their content but preserve inner HTML
    // Step 2: Remove <i class="material-icons"> tags and their content
    // Step 3: Replace &nbsp; with a space
    return html
        .replace(/<div[^>]*>(.*?)<\/div>/gis, '$1')
        .replace(/<i class="material-icons">[^<]*<\/i>/gi, '')
        .replace(/&nbsp;/gi, ' ')
        .trim();
}
function addSeriesToYAxis(chart, yAxisId, para, data, curveName, color) {
    const seriesType = getChartTypeByPara(para);
    const options = {
        id: para,
        yAxis: yAxisId,
        data,
        name: curveName
            ? curveName
            : sanitizeTechniqueColumnTitle(getTechniqueColumnTitle(para)) ||
                labColumnsToTitle[para] ||
                labEntitiesColumnsToTitle[para],
        type: seriesType.type,
        lineWidth: seriesType.lineWidth,
        marker: { enabled: seriesType.showMarker },
    };
    if (color) {
        options.color = color;
    }
    chart.addSeries(options);
}
let AxisTitleObject = {};
function clearAxisTitleObject() {
    AxisTitleObject = {};
}
function addYaxis(chart, yAxisId) {
    if (chart && !chart.get(yAxisId)) {
        chart.addAxis({
            id: yAxisId,
            margin: -10,
            title: {
                text: yAxisId,
            },
            labels: {
                format: '{value}',
            },
            opposite: true,
            showEmpty: false,
        });
    }
}
let offsetXAxis = {};
function clearOffsetXAxis() {
    offsetXAxis = {};
}
function getXAxisId(para, surveyId, position) {
    return 'axis' + para + '-' + surveyId + '-' + position;
}
function getTickPositions(min, max, interval) {
    if (interval <= 0) {
        return [min, max];
    }
    const tickPositionList = [];
    let i;
    for (i = min; i <= max; i += interval) {
        tickPositionList.push(i);
    }
    if (i !== max) {
        tickPositionList.push(max);
    }
    return tickPositionList;
}
function addXAxis(chart, surveyId, axisWidth, axisLeft, position, para, scaleInfo) {
    const xAxisId = getXAxisId(para, surveyId, position);
    if (!AxisTitleObject[xAxisId]) {
        AxisTitleObject[xAxisId] = [];
    }
    AxisTitleObject[xAxisId].push(getTechniqueColumnTitle(para) ||
        labColumnsToTitle[para] ||
        labEntitiesColumnsToTitle[para]);
    if (chart && !chart.get(xAxisId)) {
        const offsetId = surveyId + position;
        if (offsetXAxis[offsetId] === undefined) {
            offsetXAxis[offsetId] = 5;
        }
        else {
            offsetXAxis[offsetId] += 50;
        }
        chart.addAxis({
            id: xAxisId,
            labels: {
                format: '{value}',
            },
            lineWidth: position === 'left' ? 1 : 2,
            showEmpty: false,
            width: axisWidth,
            left: axisLeft,
            offset: offsetXAxis[offsetId],
            crosshair: true,
            min: scaleInfo[para].min,
            max: scaleInfo[para].max,
            tickPositioner() {
                return getTickPositions(this.min, this.max, scaleInfo[para].interval);
            },
        }, true, false);
    }
    ;
    chart.get(xAxisId)?.setTitle({ text: AxisTitleObject[xAxisId].join(), useHTML: true }, false);
}
function addSeriesToXAxis(chart, para, data, surveyId, position, curveName, color) {
    const seriesType = getChartTypeByPara(para);
    const seriesId = para + '-' + surveyId + '-' + position;
    if (chart) {
        chart.get(seriesId)?.remove();
        const options = {
            id: seriesId,
            xAxis: getXAxisId(para, surveyId, position),
            data,
            showInLegend: false,
            name: curveName
                ? curveName
                : getTechniqueColumnTitle(para) ||
                    labColumnsToTitle[para] ||
                    labEntitiesColumnsToTitle[para],
            type: seriesType.type,
            lineWidth: seriesType.lineWidth,
            marker: { enabled: seriesType.showMarker },
            zIndex: 100,
            tooltip: {
                headerFormat: '<b>{series.name}</b><br>',
                pointFormat: 'Depth: {point.y:.2f}m <br> Value: {point.x:.2f}',
            },
        };
        if (color) {
            options.color = color;
        }
        chart.addSeries(options, false);
    }
}
function addSeriesAndXAxisToCrossSection(chart, para, data, surveyId, axisWidth, axisLeft, position, scaleInfo, color, curveName) {
    addXAxis(chart, surveyId, axisWidth, axisLeft, position, para, scaleInfo);
    const cutData = getDataWithScaleMinMax(scaleInfo[para], data);
    addSeriesToXAxis(chart, para, cutData, surveyId, position, curveName, color);
}
function getDataWithScaleMinMax(scale, data) {
    const cutData = cloneDeep(data);
    return cutData.map((row) => {
        if (row[0] < scale.min) {
            row[0] = scale.min;
        }
        else if (row[0] > scale.max) {
            row[0] = scale.max;
        }
        return row;
    });
}

class SeriesDataMathService {
    soilTypeUtilsService;
    constructor(soilTypeUtilsService) {
        this.soilTypeUtilsService = soilTypeUtilsService;
    }
    sideCoordOfColumn(chart, xValue, columnWidth) {
        const xAxis = chart.xAxis[0];
        const halfwidth = columnWidth / 2 - 5;
        const valuePixel = xAxis.toPixels(xValue, false);
        return {
            left: xAxis.toValue(valuePixel - halfwidth),
            right: xAxis.toValue(valuePixel + halfwidth),
        };
    }
    filterNullData(stratigraphyData) {
        // eslint-disable-next-line no-constant-condition
        while (true) {
            if (!stratigraphyData.data || stratigraphyData.data.length === 0) {
                break;
            }
            const lastEle = stratigraphyData.data.pop();
            if (lastEle[lastEle.length - 1]) {
                stratigraphyData.data.push(lastEle);
                break;
            }
        }
    }
    deleteFirstZeroDepthData(stratigraphyData) {
        stratigraphyData.data = stratigraphyData.data.filter(data => data[0]);
    }
    toggleElevationMode(seriesData, elevationMode) {
        return (seriesData || [])?.map((row) => {
            if (row && row.elevationMode !== elevationMode && row.data) {
                const { elevation, data } = row;
                return {
                    ...row,
                    data: data.map((item) => {
                        const base = typeof elevation === 'number'
                            ? elevation
                            : elevation && item.x in elevation
                                ? Number(elevation[item.x])
                                : 0;
                        return {
                            x: item.x,
                            high: base - item.low,
                            low: base - item.high,
                        };
                    }),
                    elevationMode,
                };
            }
            else {
                return row;
            }
        });
    }
    getCrossSectionDataSeries(crossSectionStratigraphyData, translateService, datumDisplayName) {
        const levelData = [];
        const seriesDataArray = [];
        const xAxisLabelObject = {};
        const xAxisTickPositions = [];
        let showCheckbox = true;
        if (crossSectionStratigraphyData.find((item) => item.elevation === null)) {
            showCheckbox = false;
        }
        crossSectionStratigraphyData.forEach((item) => {
            let xLabel = item.name;
            if (item.projectDis != null) {
                xLabel = xLabel + ' <br> proj:' + item.projectDis.toFixed(2) + 'm';
            }
            const supInfos = getBoreholeTypeName(item.type, translateService) +
                '-' +
                item.elevation +
                datumDisplayName;
            xAxisLabelObject[item.xValue] =
                '<span title="' + supInfos + '"> ' + xLabel + '</span>';
            xAxisTickPositions.push(item.xValue);
            if (item.data && item.data.length > 0) {
                this.deleteFirstZeroDepthData(item);
                const itemSeriesData = this.getSeriesDataOfOneSurvey(item, 'cross-section', showCheckbox);
                for (let i = 0; i < itemSeriesData.length; i++) {
                    if (levelData[i] === undefined) {
                        levelData[i] = [];
                    }
                    levelData[i].push(itemSeriesData[i]);
                }
            }
        });
        let soilTypesArray = [];
        levelData.forEach(oneLevel => {
            const temp = oneLevel.slice();
            temp.sort((a, b) => {
                return a.depth - b.depth;
            });
            // get an array of soiltype without duplicate
            const soilTypes = temp
                .filter(item => item.soiltype != null)
                .map(item => item.soiltype);
            const uniqueSoilTypes = soilTypes.filter((item, pos) => {
                return soilTypes.indexOf(item) === pos;
            });
            uniqueSoilTypes.forEach(soil => {
                const oneSeries = {
                    name: soil,
                    type: 'columnrange',
                    data: [],
                    color: this.soilTypeUtilsService.getSoilPattern(soil),
                    showInLegend: soil !== 'none' && !soilTypesArray.includes(soil),
                    elevation: {},
                    elevationMode: null,
                };
                for (const onel of oneLevel) {
                    if (onel.soiltype === soil) {
                        oneSeries.data = oneSeries.data.concat(onel.data);
                    }
                    else if (onel.data) {
                        const zeroValue = {
                            x: onel.data[0].x,
                            low: onel.data[0].low,
                            high: onel.data[0].low,
                        };
                        oneSeries.data.push(zeroValue);
                    }
                    oneSeries.elevation[onel.data[0].x] = onel.elevation;
                    oneSeries.elevationMode = onel.elevationMode;
                }
                seriesDataArray.push(oneSeries);
            });
            soilTypesArray = soilTypesArray.concat(uniqueSoilTypes);
        });
        return {
            xAxisLabelObject,
            xAxisTickPositions,
            seriesDataArray,
            showCheckbox,
        };
    }
    getSeriesDataOfZone(stratigraphyData) {
        // filter the data item which has invalid toit or base (null or '')
        const filteredData = stratigraphyData.data.filter(item => {
            return (item[0] !== '' &&
                item[0] !== 'null' &&
                item[0] !== null &&
                item[1] !== '' &&
                item[1] !== 'null' &&
                item[1] !== null &&
                item[1] > item[0]);
        });
        return filteredData.map(item => {
            let serieName = '';
            let espace = [];
            if (item[1] - item[0] > 0) {
                espace = [{ x: 0, low: item[0], high: item[1] }];
                serieName = item[2] ? item[2] : 'No data';
            }
            return {
                type: 'columnrange',
                name: serieName,
                data: espace,
                color: this.soilTypeUtilsService.getSoilPattern(item[2]),
            };
        });
    }
    getSeriesDataOfOneSurvey(stratigraphyData, type = '', elevationMode = false) {
        let previousDepth = 0;
        const elevation = Number(stratigraphyData.elevation);
        let seriesData = stratigraphyData.data.map((item, index, array) => {
            let serieName;
            let espace = [];
            if (index > 0) {
                previousDepth = Number(array[index - 1][0]);
                if (Number(previousDepth) === 0) {
                    // the value invalid will be considered as 0
                    let count = index - 1;
                    while (count > 0) {
                        if (Number(array[count - 1][0])) {
                            previousDepth = Number(array[count - 1][0]);
                            break;
                        }
                        count--;
                    }
                    if (count === 0) {
                        previousDepth = 0;
                    }
                }
            }
            if (Number(item[0]) - previousDepth > 0) {
                if (elevationMode) {
                    espace = [
                        {
                            x: type === 'cross-section' ? stratigraphyData.xValue : 0,
                            high: elevation - previousDepth,
                            low: elevation - Number(item[0]),
                        },
                    ];
                }
                else {
                    espace = [
                        {
                            x: type === 'cross-section' ? stratigraphyData.xValue : 0,
                            low: previousDepth,
                            high: Number(item[0]),
                        },
                    ];
                }
                serieName = item[1] ? item[1] : 'none';
            }
            else {
                serieName = 'invalid';
            }
            const soiltype = item[1] ? item[1] : 'none';
            return {
                type: 'columnrange',
                name: serieName,
                data: espace,
                soiltype,
                depth: Number(item[0]),
                color: this.soilTypeUtilsService.getSoilPattern(soiltype),
                elevation,
                elevationMode,
            };
        });
        seriesData = this.groupSameSoiltype(seriesData, elevationMode);
        return seriesData;
    }
    groupSameSoiltype(seriesData, elevationMode) {
        if (seriesData && seriesData.length > 0) {
            const groupedSeriesData = [];
            let groupeData = JSON.parse(JSON.stringify(seriesData[0]));
            let compareType = seriesData[0].soiltype;
            for (let i = 1; i < seriesData.length; i++) {
                if (seriesData[i].soiltype === compareType) {
                    groupeData.depth = seriesData[i].depth;
                    if (elevationMode) {
                        groupeData.data[0].low = seriesData[i].data[0]?.low;
                    }
                    else {
                        groupeData.data[0].high = seriesData[i].data[0]?.high;
                    }
                }
                else {
                    groupedSeriesData.push(groupeData);
                    compareType = seriesData[i].soiltype;
                    groupeData = JSON.parse(JSON.stringify(seriesData[i]));
                }
            }
            groupedSeriesData.push(groupeData);
            return groupedSeriesData;
        }
        else {
            return seriesData;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SeriesDataMathService, deps: [{ token: SoilTypeUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SeriesDataMathService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SeriesDataMathService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: SoilTypeUtilsService }]; } });

highcharts(Highcharts);
highcharts0(Highcharts);
highcharts01(Highcharts);
highcharts012(Highcharts);
highcharts0123(Highcharts);
highcharts01234(Highcharts);
class StratigraphyRenderingChartComponent {
    translateService;
    dialog;
    seriesDataMathService;
    stratigraphyData;
    crossSectionStratigraphyData;
    chartFrom;
    depthMax;
    tickInterval = 1;
    chartIndexStr = '';
    unifiedMarginTop;
    labTestDataArray;
    selectedCrossSectionParameters;
    elevationMode;
    datumDisplayName;
    highlightBoreholeEvent = new EventEmitter();
    setSelectedTestParametersEvent = new EventEmitter();
    chart;
    xAxisCategories = [];
    xAxisTickPositions = [];
    xAxisLabelObject = {};
    useCategories;
    seriesData = [];
    marginTop = 80;
    marginLeft = 70;
    marginbottom = 70;
    marginRight = 40;
    columnWidth = 80;
    // for cross-section
    columnWidthMax = 30;
    columnWidthMin = 20;
    chartName = '';
    yAxisTitle = 'Depth';
    showCheckbox = false;
    checked = false;
    elevationLine;
    soiltypePolygonSeries = [];
    elevationMin = 0;
    highlightId;
    exportFileName;
    chartSourceWidth;
    chartSourceHeight;
    windowResized = false;
    boreholesNoData;
    depthFormControl;
    depthSubscription;
    customDepthMax;
    selectedTestParameters;
    aixPosition;
    noElevationMessage;
    static isLinkableSeries(series) {
        for (const serie of series) {
            if (!allValuePositive(serie.data) && serie.name !== 'elevationLine') {
                return false;
            }
        }
        return true;
    }
    constructor(translateService, dialog, seriesDataMathService) {
        this.translateService = translateService;
        this.dialog = dialog;
        this.seriesDataMathService = seriesDataMathService;
    }
    onResize(_) {
        this.windowResized = true;
    }
    ngOnInit() {
        this.depthFormControl = new FormControl(null, {
            validators: [Validators.min(1)],
            updateOn: 'blur',
        });
        this.depthSubscription = this.depthFormControl.valueChanges.subscribe(value => {
            if (this.depthFormControl.valid) {
                this.customDepthMax = value;
                this.loadChart();
                this.loadChartWithPolygonsSeries();
            }
        });
    }
    openParaDialog() {
        const dialogRef = this.dialog.open(SelectParametersDialogComponent, {
            width: '80vw',
            data: {
                data: this.crossSectionStratigraphyData,
                labData: this.labTestDataArray,
                initSelectorData: this.selectedTestParameters,
            },
        });
        dialogRef
            .afterClosed()
            .subscribe((selectedParameters) => {
            if (selectedParameters) {
                this.selectedTestParameters = selectedParameters;
                this.setSelectedTestParametersEvent.emit(this.selectedTestParameters);
                this.loadParameterGraphs();
            }
        });
    }
    loadParameterGraphs() {
        this.loadChart();
        this.loadChartWithPolygonsSeries();
        if (this.selectedTestParameters) {
            for (const position of Object.keys(this.selectedTestParameters)) {
                this.loadTestSeries(this.selectedTestParameters[position], position === 'right');
            }
        }
        this.chart.redraw();
    }
    ngOnDestroy() {
        if (this.depthSubscription) {
            this.depthSubscription.unsubscribe();
        }
    }
    switchElevationMode(checked) {
        if (checked) {
            this.depthFormControl.disable();
            this.setElevationLayer();
            this.yAxisTitle = this.translateService.instant('SURVEY.ELEVATION', {
                name: this.datumDisplayName,
            });
            this.seriesData = this.seriesData.filter(item => item.type !== 'polygon');
            this.seriesData = this.seriesDataMathService.toggleElevationMode(this.seriesData, checked);
            this.seriesData.push(this.elevationLine);
        }
        else {
            this.depthFormControl.enable();
            this.seriesData = this.seriesData.filter(item => item.type !== 'polygon' && item.name !== 'elevationLine');
            this.seriesData = this.seriesDataMathService.toggleElevationMode(this.seriesData, checked);
            this.initCrossSectionStratigraphy();
        }
    }
    onChange(e) {
        this.switchElevationMode(e.checked);
        this.loadParameterGraphs();
    }
    initCrossSectionStratigraphy() {
        this.elevationMin = 0;
        this.yAxisTitle = this.translateService.instant('GENERAL.DEPTH');
        this.elevationLine = null;
    }
    initOptions() {
        this.depthFormControl?.setValue(null);
        this.selectedTestParameters = null;
        this.aixPosition = null;
    }
    loadChartWithPolygonsSeries() {
        this.getSoilTypePolygonsSeries(this.seriesData);
        this.seriesData = this.seriesData.concat(this.soiltypePolygonSeries);
        this.loadChart();
    }
    loadTestSeries(DataObject, right = false) {
        const ParaDataObject = DataObject?.data;
        if (ParaDataObject) {
            clearOffsetXAxis();
            if (!this.aixPosition) {
                this.aixPosition = this.getPixelPosition();
            }
            const minimumWidth = getMinPixelWidth(this.aixPosition, this.columnWidth);
            if (this.chart) {
                for (const id in ParaDataObject) {
                    if (ParaDataObject[id]) {
                        const paras = Object.keys(ParaDataObject[id]);
                        clearAxisTitleObject();
                        paras?.map(para => {
                            addSeriesAndXAxisToCrossSection(this.chart, para, this.checked
                                ? ParaDataObject[id][para].elevationData
                                : ParaDataObject[id][para].data, id, minimumWidth, right
                                ? this.aixPosition[id].center
                                : this.aixPosition[id].center - minimumWidth, right ? 'right' : 'left', DataObject.scale, undefined, undefined);
                        });
                    }
                }
            }
        }
    }
    ngOnChanges(changes) {
        if (changes.selectedCrossSectionParameters?.currentValue) {
            this.selectedTestParameters = this.selectedCrossSectionParameters;
            if (this.selectedTestParameters?.left?.type ||
                this.selectedTestParameters?.right?.type) {
                setTimeout(() => {
                    this.loadParameterGraphs();
                }, 500);
            }
        }
        if (changes.crossSectionStratigraphyData?.currentValue &&
            JSON.stringify(changes.crossSectionStratigraphyData.previousValue !==
                JSON.stringify(changes.crossSectionStratigraphyData.currentValue))) {
            if (this.chartFrom === 'cross-section') {
                this.boreholesNoData = null;
                this.useCategories = false;
                this.exportFileName = 'Cross-section stratigraphy';
                if (this.crossSectionStratigraphyData.length === 0) {
                    this.destroyChart();
                    this.showCheckbox = false;
                    return;
                }
                this.initOptions();
                this.initCrossSectionStratigraphy();
                this.crossSectionStratigraphyData.forEach(item => {
                    this.seriesDataMathService.filterNullData(item);
                });
                this.boreholesNoData = this.crossSectionStratigraphyData.filter(item => !item.data || item.data.length === 0);
                this.crossSectionStratigraphyData =
                    this.crossSectionStratigraphyData.filter(item => item.data && item.data.length > 0);
                const results = this.seriesDataMathService.getCrossSectionDataSeries(this.crossSectionStratigraphyData, this.translateService, this.datumDisplayName);
                this.showCheckbox = results.showCheckbox;
                this.xAxisLabelObject = results.xAxisLabelObject;
                this.xAxisTickPositions = results.xAxisTickPositions;
                this.seriesData = results.seriesDataArray;
                if (this.showCheckbox) {
                    this.checked = true;
                    this.switchElevationMode(this.checked);
                    this.noElevationMessage = null;
                }
                else {
                    this.checked = false;
                    this.depthFormControl?.enable();
                    this.noElevationMessage = 'CROSS_SECTION.NO_ELEVATION_MESS';
                }
                this.loadChart();
                this.loadChartWithPolygonsSeries();
            }
        }
        if ((changes.stratigraphyData?.currentValue &&
            JSON.stringify(changes.stratigraphyData.previousValue) !==
                JSON.stringify(changes.stratigraphyData.currentValue)) ||
            changes.unifiedMarginTop ||
            (changes.elevationMode && !changes.elevationMode.firstChange)) {
            this.loadSingleStratigraphyGraph();
        }
    }
    loadSingleStratigraphyGraph() {
        this.useCategories = true;
        this.exportFileName = 'Stratigraphy';
        this.marginTop = this.unifiedMarginTop;
        this.seriesData = [];
        this.checked = this.elevationMode;
        if (this.stratigraphyData?.data?.length > 0) {
            this.xAxisCategories = [this.stratigraphyData.name];
            this.yAxisTitle = this.elevationMode
                ? this.translateService.instant('SURVEY.ELEVATION', {
                    name: this.datumDisplayName,
                })
                : this.translateService.instant('GENERAL.DEPTH');
            this.seriesDataMathService.filterNullData(this.stratigraphyData);
            // case Edit Survey
            if (this.stratigraphyData.data[0] &&
                this.stratigraphyData.data[0].length === 2) {
                this.seriesDataMathService.deleteFirstZeroDepthData(this.stratigraphyData);
                this.seriesData = this.seriesDataMathService.getSeriesDataOfOneSurvey(this.stratigraphyData, '', this.elevationMode);
                // case Edit Cutting
            }
            else if (this.stratigraphyData.data[0] &&
                this.stratigraphyData.data[0].length === 3) {
                this.seriesData = this.seriesDataMathService.getSeriesDataOfZone(this.stratigraphyData);
            }
            this.seriesData = this.seriesData.filter(item => {
                return item.name !== 'invalid';
            });
        }
        if (this.chartFrom === 'surveyEdition' ||
            this.chartFrom === 'cuttingEdition') {
            this.chartName = 'Stratigraphy';
        }
        this.loadChart();
    }
    setElevationLayer() {
        this.elevationLine = {
            name: 'elevationLine',
            showInLegend: false,
            type: 'line',
            data: [],
            marker: {
                enabled: false,
            },
            enableMouseTracking: false,
            color: 'gray',
            zIndex: -2,
        };
        this.crossSectionStratigraphyData.forEach(item => {
            if (item.elevation !== null) {
                this.elevationLine.data.push({
                    x: item.xValue,
                    y: Number(item.elevation),
                });
            }
        });
    }
    getPixelPosition() {
        if (this.chart?.xAxis) {
            const xAxis = this.chart.xAxis[0];
            const pixebPositionObject = {};
            this.crossSectionStratigraphyData?.map((item, index, array) => {
                const chartWidth = document.getElementById('renderContainer' + this.chartIndexStr)?.clientWidth;
                pixebPositionObject[item.id] = {
                    width: index === 0
                        ? xAxis.toPixels(item.xValue, false) - this.marginLeft
                        : (xAxis.toPixels(item.xValue, false) -
                            xAxis.toPixels(array[index - 1].xValue, false)) /
                            2,
                    center: xAxis.toPixels(item.xValue, false),
                    widthR: index === array.length - 1
                        ? chartWidth -
                            xAxis.toPixels(item.xValue, false) -
                            this.marginRight
                        : (xAxis.toPixels(array[index + 1].xValue, false) -
                            xAxis.toPixels(item.xValue, false)) /
                            2,
                };
            });
            return pixebPositionObject;
        }
        else {
            return null;
        }
    }
    adjustColumnWidth() {
        let differ = Number.MAX_VALUE;
        let leftX = 0;
        let rightX = 0;
        for (let i = 1; i < this.xAxisTickPositions.length; i++) {
            if (Math.abs(this.xAxisTickPositions[i] - this.xAxisTickPositions[i - 1]) <
                differ) {
                differ = Math.abs(this.xAxisTickPositions[i] - this.xAxisTickPositions[i - 1]);
                leftX = this.xAxisTickPositions[i - 1];
                rightX = this.xAxisTickPositions[i];
            }
        }
        const xAxis = this.chart.xAxis[0];
        const minDifferPixel = Math.abs(xAxis.toPixels(rightX, false) - xAxis.toPixels(leftX, false));
        this.columnWidth = Math.min(this.columnWidthMax, Math.max(this.columnWidthMin, minDifferPixel));
    }
    getSoilTypePolygonsSeries(typeSeries) {
        if (typeSeries && typeSeries.length > 0 && this.chart) {
            this.adjustColumnWidth();
            this.soiltypePolygonSeries = [];
            let series = typeSeries.slice();
            series = series.filter(item => item.name !== 'elevationLine' && item.name !== 'Polygon');
            if (StratigraphyRenderingChartComponent.isLinkableSeries(series)) {
                for (const serie of series) {
                    const seriesData = serie.data;
                    for (let k = 0; k < seriesData.length - 1; k++) {
                        const firstX = seriesData[k].x;
                        const secondX = seriesData[k + 1].x;
                        const polygon = [
                            [
                                this.seriesDataMathService.sideCoordOfColumn(this.chart, firstX, this.columnWidth).right,
                                seriesData[k].low,
                            ],
                            [
                                this.seriesDataMathService.sideCoordOfColumn(this.chart, firstX, this.columnWidth).right,
                                seriesData[k].high,
                            ],
                            [
                                this.seriesDataMathService.sideCoordOfColumn(this.chart, secondX, this.columnWidth).left,
                                seriesData[k + 1].high,
                            ],
                            [
                                this.seriesDataMathService.sideCoordOfColumn(this.chart, secondX, this.columnWidth).left,
                                seriesData[k + 1].low,
                            ],
                        ];
                        const polygonSeries = {
                            name: 'Polygon',
                            type: 'polygon',
                            data: polygon,
                            showInLegend: false,
                            color: serie.color,
                            zIndex: -1,
                            enableMouseTracking: false,
                        };
                        this.soiltypePolygonSeries.push(polygonSeries);
                    }
                }
            }
        }
    }
    ngAfterViewInit() {
        this.loadSingleStratigraphyGraph();
    }
    getIdbyxValue(xValue) {
        for (const data of this.crossSectionStratigraphyData) {
            if (data.xValue === xValue) {
                return data.id;
            }
        }
        return null;
    }
    loadChart() {
        const ele = document.getElementById('renderContainer' + this.chartIndexStr);
        if (ele) {
            this.destroyChart();
            this.chartSourceHeight = ele.clientHeight;
            this.chartSourceWidth = ele.clientWidth;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.chart = Highcharts.chart('renderContainer' + this.chartIndexStr, {
                chart: {
                    zooming: this.chartFrom === 'cross-section' ? { type: 'xy' } : undefined,
                    marginTop: this.marginTop,
                    marginBottom: this.chartFrom === 'cross-section' ? undefined : this.marginbottom,
                    marginRight: this.marginRight,
                    marginLeft: this.marginLeft,
                    events: {
                        redraw: _ => {
                            if (this.windowResized && this.chartFrom === 'cross-section') {
                                this.windowResized = false;
                                setTimeout(() => {
                                    this.aixPosition = this.getPixelPosition();
                                    this.loadParameterGraphs();
                                }, 10);
                            }
                        },
                    },
                },
                title: {
                    useHTML: true,
                    text: this.chartName,
                },
                xAxis: {
                    id: 'startigraph',
                    categories: this.useCategories ? this.xAxisCategories : undefined,
                    tickPositions: this.xAxisTickPositions,
                    opposite: true,
                    minRange: 0.1,
                    labels: {
                        formatter() {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            const labelobj = this.axis.options.labels.labelobject;
                            return labelobj[this.value];
                        },
                        labelobject: this.xAxisLabelObject,
                        useHTML: true,
                        rotation: 90,
                    },
                },
                yAxis: {
                    min: this.checked ? undefined : 0,
                    max: this.checked
                        ? null
                        : this.chartFrom === 'cross-section'
                            ? this.customDepthMax
                            : this.depthMax,
                    tickInterval: this.tickInterval,
                    reversed: !this.checked,
                    lineWidth: 1,
                    crosshair: true,
                    endOnTick: true,
                    showLastLabel: true,
                    startOnTick: true,
                    title: {
                        text: this.yAxisTitle,
                    },
                },
                legend: {
                    enabled: this.chartFrom === 'cross-section',
                    symbolRadius: 0,
                    squareSymbol: false,
                    symbolHeight: 15,
                    symbolWidth: 25,
                },
                exporting: {
                    sourceHeight: this.chartSourceHeight,
                    sourceWidth: this.chartSourceWidth,
                    filename: this.exportFileName,
                    buttons: {
                        contextButton: {
                            menuItems: [
                                'viewFullscreen',
                                'separator',
                                'downloadPNG',
                                'downloadJPEG',
                                'downloadSVG',
                            ],
                        },
                    },
                },
                credits: {
                    enabled: false,
                },
                plotOptions: {
                    columnrange: {
                        grouping: false,
                        pointWidth: this.columnWidth,
                    },
                    series: {
                        point: {
                            events: {
                                mouseOver: (e) => {
                                    if (this.chartFrom === 'cross-section') {
                                        const p = e.target;
                                        if (this.crossSectionStratigraphyData) {
                                            const focusId = this.getIdbyxValue(p.x);
                                            if (focusId && this.highlightId !== focusId) {
                                                this.highlightId = focusId;
                                                this.highlightBoreholeEvent.emit(this.highlightId);
                                            }
                                        }
                                    }
                                },
                            },
                        },
                        events: {
                            mouseOut: () => {
                                if (this.chartFrom === 'cross-section') {
                                    this.highlightId = null;
                                    this.highlightBoreholeEvent.emit(null);
                                }
                            },
                            legendItemClick(e) {
                                e.preventDefault();
                            },
                        },
                    },
                },
                boost: {
                    enabled: false,
                },
                tooltip: {
                    useHTML: true,
                    headerFormat: this.chartFrom === 'cross-section' ? 'x: {point.x:.2f}m<br/>' : '',
                    pointFormat: 'type: <b>{series.name}</b> <br> from: {point.low:.2f}m <br> to {point.high:.2f}m',
                },
                series: this.seriesData,
            });
        }
    }
    destroyChart() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: StratigraphyRenderingChartComponent, deps: [{ token: i1$1.TranslateService }, { token: i1$2.MatDialog }, { token: SeriesDataMathService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.9", type: StratigraphyRenderingChartComponent, selector: "ssd-soillib-lib-stratigraphy-rendering-chart", inputs: { stratigraphyData: "stratigraphyData", crossSectionStratigraphyData: "crossSectionStratigraphyData", chartFrom: "chartFrom", depthMax: "depthMax", tickInterval: "tickInterval", chartIndexStr: "chartIndexStr", unifiedMarginTop: "unifiedMarginTop", labTestDataArray: "labTestDataArray", selectedCrossSectionParameters: "selectedCrossSectionParameters", elevationMode: "elevationMode", datumDisplayName: "datumDisplayName" }, outputs: { highlightBoreholeEvent: "highlightBoreholeEvent", setSelectedTestParametersEvent: "setSelectedTestParametersEvent" }, host: { listeners: { "window:resize": "onResize($event)" } }, usesOnChanges: true, ngImport: i0, template: `
    <div class="flex-layout-column">
      <div
        class="flex-layout-row flex-align-space-between--center flex-gap-20px"
        *ngIf="chartFrom === 'cross-section' && chart"
      >
        <mat-slide-toggle
          color="warn"
          (change)="onChange($event)"
          *ngIf="showCheckbox"
        >
          {{ 'SURVEY.ELEVATION' | translate : { name: datumDisplayName } }}
        </mat-slide-toggle>
        <button mat-raised-button (click)="openParaDialog()">
          {{ 'CROSS_SECTION.PLOT_GRAPHS' | translate }}
        </button>
        <div>
          <mat-form-field>
            <input
              matInput
              matTooltip=""
              placeholder="MAX Depth"
              [formControl]="depthFormControl"
            />
            <span matSuffix>m</span>
          </mat-form-field>
        </div>
      </div>
      <div
        *ngIf="boreholesNoData && boreholesNoData.length > 0"
        class="message"
      >
        <mat-icon>info</mat-icon>
        <span>{{ 'COMPARISON.NO_DATA' | translate }}: </span>
        <span *ngFor="let bh of boreholesNoData">{{ bh.name }},</span>
      </div>
      <div *ngIf="noElevationMessage" class="message">
        <mat-icon>info</mat-icon>
        <span translate>{{ noElevationMessage }}</span>
      </div>
    </div>
    <div
      [ngClass]="{ 'custom-height': chartFrom === 'cross-section' }"
      id="{{ 'renderContainer' + chartIndexStr }}"
    ></div>
  `, isInline: true, styles: ["mat-form-field{max-width:100px}.message{color:gray;font-size:11px;display:flex;align-items:center}.custom-height{min-height:530px}\n"], dependencies: [{ kind: "directive", type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i5.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i7.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i7.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "component", type: i8.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i10$1.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matSlideToggle"] }, { kind: "directive", type: i11$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i1$1.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: StratigraphyRenderingChartComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ssd-soillib-lib-stratigraphy-rendering-chart', template: `
    <div class="flex-layout-column">
      <div
        class="flex-layout-row flex-align-space-between--center flex-gap-20px"
        *ngIf="chartFrom === 'cross-section' && chart"
      >
        <mat-slide-toggle
          color="warn"
          (change)="onChange($event)"
          *ngIf="showCheckbox"
        >
          {{ 'SURVEY.ELEVATION' | translate : { name: datumDisplayName } }}
        </mat-slide-toggle>
        <button mat-raised-button (click)="openParaDialog()">
          {{ 'CROSS_SECTION.PLOT_GRAPHS' | translate }}
        </button>
        <div>
          <mat-form-field>
            <input
              matInput
              matTooltip=""
              placeholder="MAX Depth"
              [formControl]="depthFormControl"
            />
            <span matSuffix>m</span>
          </mat-form-field>
        </div>
      </div>
      <div
        *ngIf="boreholesNoData && boreholesNoData.length > 0"
        class="message"
      >
        <mat-icon>info</mat-icon>
        <span>{{ 'COMPARISON.NO_DATA' | translate }}: </span>
        <span *ngFor="let bh of boreholesNoData">{{ bh.name }},</span>
      </div>
      <div *ngIf="noElevationMessage" class="message">
        <mat-icon>info</mat-icon>
        <span translate>{{ noElevationMessage }}</span>
      </div>
    </div>
    <div
      [ngClass]="{ 'custom-height': chartFrom === 'cross-section' }"
      id="{{ 'renderContainer' + chartIndexStr }}"
    ></div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["mat-form-field{max-width:100px}.message{color:gray;font-size:11px;display:flex;align-items:center}.custom-height{min-height:530px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.TranslateService }, { type: i1$2.MatDialog }, { type: SeriesDataMathService }]; }, propDecorators: { stratigraphyData: [{
                type: Input
            }], crossSectionStratigraphyData: [{
                type: Input
            }], chartFrom: [{
                type: Input
            }], depthMax: [{
                type: Input
            }], tickInterval: [{
                type: Input
            }], chartIndexStr: [{
                type: Input
            }], unifiedMarginTop: [{
                type: Input
            }], labTestDataArray: [{
                type: Input
            }], selectedCrossSectionParameters: [{
                type: Input
            }], elevationMode: [{
                type: Input
            }], datumDisplayName: [{
                type: Input
            }], highlightBoreholeEvent: [{
                type: Output
            }], setSelectedTestParametersEvent: [{
                type: Output
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class StratigraphyService {
    soilTypeUtilsService;
    constructor(soilTypeUtilsService) {
        this.soilTypeUtilsService = soilTypeUtilsService;
    }
    getStratigraphyData(survey, surveyData) {
        const isSBT = survey.type?.includes('CPT');
        return {
            name: survey.name,
            data: this.soilTypeUtilsService
                .parseSoilTypes(surveyData, isSBT)
                .map(({ calculated_soil, depth }) => [depth, calculated_soil]),
            elevation: survey.elevation,
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: StratigraphyService, deps: [{ token: SoilTypeUtilsService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: StratigraphyService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: StratigraphyService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: SoilTypeUtilsService }]; } });

class SsdSoillibLibModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SsdSoillibLibModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.9", ngImport: i0, type: SsdSoillibLibModule, declarations: [JobsiteSoilStatsComponent,
            StratigraphyRenderingChartComponent,
            SelectParametersDialogComponent], imports: [CommonModule,
            TranslateModule,
            MatButtonModule,
            MatInputModule,
            MatFormFieldModule,
            MatIconModule,
            ReactiveFormsModule,
            MatDialogModule,
            MatSlideToggleModule,
            MatOptionModule,
            MatSelectModule,
            MatTabsModule,
            MatCardModule,
            MatTooltipModule], exports: [JobsiteSoilStatsComponent,
            StratigraphyRenderingChartComponent,
            SelectParametersDialogComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SsdSoillibLibModule, providers: [
            JobsiteService,
            SoilStatsService,
            SoilSurveyService,
            SoilTypeUtilsService,
            StratigraphyService,
            SeriesDataMathService,
        ], imports: [CommonModule,
            TranslateModule,
            MatButtonModule,
            MatInputModule,
            MatFormFieldModule,
            MatIconModule,
            ReactiveFormsModule,
            MatDialogModule,
            MatSlideToggleModule,
            MatOptionModule,
            MatSelectModule,
            MatTabsModule,
            MatCardModule,
            MatTooltipModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SsdSoillibLibModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        JobsiteSoilStatsComponent,
                        StratigraphyRenderingChartComponent,
                        SelectParametersDialogComponent,
                    ],
                    imports: [
                        CommonModule,
                        TranslateModule,
                        MatButtonModule,
                        MatInputModule,
                        MatFormFieldModule,
                        MatIconModule,
                        ReactiveFormsModule,
                        MatDialogModule,
                        MatSlideToggleModule,
                        MatOptionModule,
                        MatSelectModule,
                        MatTabsModule,
                        MatCardModule,
                        MatTooltipModule,
                    ],
                    exports: [
                        JobsiteSoilStatsComponent,
                        StratigraphyRenderingChartComponent,
                        SelectParametersDialogComponent,
                    ],
                    providers: [
                        JobsiteService,
                        SoilStatsService,
                        SoilSurveyService,
                        SoilTypeUtilsService,
                        StratigraphyService,
                        SeriesDataMathService,
                    ],
                }]
        }] });

class SsdSoillibLibTranslateLoader {
    getTranslation(lang) {
        return from(import(`/node_modules/@sde-ild/ssd-soillib-lib/src/assets/i18n/${lang}.json`)).pipe(map(module => module.default));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SsdSoillibLibTranslateLoader, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SsdSoillibLibTranslateLoader, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SsdSoillibLibTranslateLoader, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const SOIL_TYPE_AGS = [
    'TOPSOIL',
    'MADE GROUND',
    'Bitumen',
    'CONCRETE',
    'CLAY',
    'Silty CLAY',
    'CLAY SILT',
    'Sandy CLAY',
    'SILT',
    'Organic CLAY',
    'Sandy SILT',
    'Clayey SILT',
    'Clayey SAND',
    'Gravelly SAND',
    'SAND and GRAVEL',
    'Organic SAND',
    'Clayey GRAVEL',
    'Sandy GRAVEL',
    'Clayey PEAT',
    'Silty PEAT',
    'Sandy PEAT',
    'ROCK',
    'SAND',
    'Silty SAND',
    'Cobbly SAND',
    'Bouldery SAND',
    'GRAVEL',
    'Silty GRAVEL',
    'Cobbly GRAVEL',
    'Bouldery GRAVEL',
    'PEAT',
    'Gravelly PEAT',
    'Cobbly PEAT',
    'COBBLES',
    'Clayey COBBLES',
    'Silty COBBLES',
    'Sandy COBBLES',
    'Organic COBBLES',
    'COBBLES and BOULDERS',
    'BOULDERS',
    'Gravelly BOULDERS',
    'MUDSTONE',
    'SILTSTONE',
    'LIMESTONE',
    'CHALK',
    'BRECCIA',
    'CONGLOMERATE',
    'Igneous ROCK',
    'Metamorphic ROCK',
    'Gypsum',
    'Shale',
    'Gravelly CLAY',
    'Cobbly CLAY',
    'Bouldery CLAY',
    'Gravelly SILT',
    'Organic SILT',
    'Cobbly SILT',
    'Bouldery SILT',
    'Organic GRAVEL',
    'Gravelly COBBLES',
    'SANDSTONE',
    'COAL',
    'Void',
    'No Rec',
    'Undetermined',
    'Wood',
];

/*
 * Public API Surface of ssd-soillib-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AGS4, BottomNavHeight, ChartIdList, Colors, GEOL, JobsiteService, JobsiteSoilStatsComponent, SCPP, SOIL_TYPE_AGS_ICON_NAME, SOIL_TYPE_AGS_SBT_EN, SOIL_TYPE_AGS_SBT_FR, SbtnZoneColor, SbtnZoneDesc, SelectParametersDialogComponent, SelectStatus, SoilStatsService, SoilSurveyService, SoilTypeUtilsService, SsdSoillibLibModule, SsdSoillibLibTranslateLoader, StratigraphyRenderingChartComponent, StratigraphyService, Zoom, addSeriesAndXAxisToCrossSection, addSeriesAndYaxis, allBoreholeTypes, allValuePositive, areArraysEqual, axisId, bhTypeToParams, bhTypeToSelectableParams, chartTitle, clearAxisTitleObject, clearOffsetXAxis, deSerializeColumnNames, getBoreholeTypeName, getBoreholeTypeSymbol, getChartMarginTop, getChartTypeByPara, getDataObject, getLabColumnTitle, getLabParameters, getMinPixelWidth, getPlotBands, getPolygonData, getScaleInfos, getSelectableColumns, getTechniqueAvailableParameters, getTechniqueColumnTitle, getTechniqueDefaultColumns, getY, getYaxisParams, getZone, labColumnsToTitle, labEntitiesColumnsToTitle, sanitizeTechniqueColumnTitle, toCrossSectionDto, yAxisTitle };
